export const ar = {
  navbar: {
    app_title: "SSR",
    messages: "الرسائل",
    notifications: "الإشعارات",
    empty_messages: "لا يوجد جديد حاليا",
    search: "بحث بواسطة: الاسم أو الحساب أو البطاقة أو البروفايل",
    terms_of_use: "شروط الاستخدام",
    privacy_policy: "سياسة الخصوصية",
  },
  sidebar: {
    dashboard: "الرئيسية",
    accounts: {
      accounts: "الحسابات",
      subscribtions: "حسابات المستخدمين",
      online_sessions: "الجلسات المتصلة",
      add: "إضافة",
    },
    profiles: {
      profiles: "البروفايلات",
      all: "الكل",
      add: "إضافة",
    },
    cards: {
      cards: "البطاقات",
      groups: "مجموعات البطاقات",
      all: "جميع البطاقات",
      generate: "توليد مجموعة بطاقات",
    },
    admins: "المدراء",
    resellers: "الوكلاء",
    support_tickets: "طلبات الصيانة",
    notifications: {
      notifications: "الإشعارات",
      auto: "الإشعارات التلقائية",
      manual: "الإشعارات اليدوية",
      app: "إشعارات التطبيق",
      wa: "Whatsapp",
    },
    nas: "الشبكات",
    nas_devices: "تجهيزات الشبكة",
    services: {
      services: "خدمات",
      mikrotik: "ميكروتيك",
      support_tickets: "طلبات الصيانة",
      bandwidth: "ضبط السرعة",
      mikrotik_log: "لوغ ميكروتيك",
    },
    settings: {
      settings: "إعدادات",
      system_settings: "خيارات النظام",
      backup: "نسخ إحتياطي",
      restore: "إستيراد",
      updates: "التحديثات",
      reset: "استعادة ضبط المصنع",
      license: "الترخيص",
      print_settings: "إعدادات الطباعة",
      payment_api: "API الدفع الخارجي",
      contracts: "العقود",
    },
    logout: "تسجيل خروج",
    admins_log: "سجل العمليات",
    accounting: "المحاسبة",
    bills: "فواتير",
    transactions: "مناقلات مالية",
    sessions_log: "سجل الاستهلاك",
    resellers_bills: "فواتير الوكلاء",
    reports: "تقارير",
    ips: "عناوين IP",
    public_ips: "العامة",
    private_ips: "المجموعات الخاصة",
    pages: "الصفحات",
    support: "الدعم الفني",
    docs: "المستندات",
    miscs: "متفرقات",
    subscription: "الاشتراك",
    profile: "البروفايل",
    sessions: "الجلسات",
    usage: "الاستهلاك",
    map: "خريطة الشبكة",
    sales: "مبيعات",
    privileges_groups: "مجموعات الصلاحيات",
    users: "المستخدمين",
    cards_bills: "فواتير البطاقات",
    credits_vouchers: "كروت شحن الرصيد",
    vouchers_batches: "مجموعات الكروت",
    all_vouchers: "جميع الكروت",
    vouchers_bills: "فواتير كروت الشحن",
  },
  login: {
    title: "SUPER SPEED - Radius Manager",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    realm: "الريلم",
    login: "دخول",
    remember_me: "تذكرني",
    forgot_password: "نسيت كلمة المرور؟",
    serial_number: "ادخل مفتاح الترخيص:",
    license: "تفعيل",
    enter_username: "ادخل اسم المستخدم",
    logout: "تسجيل الخروج",
    my_profile: "الملف الشخصي",
    internal_server_error: "خطأ داخلي في السيرفر",
    license_error: "خطأ في الترخيص",
    no_license_found: "لا يوجد ترخيص مفعل",
    database_error: "خطأ في قاعدة البيانات",
    db_connection_failed: "فشل في الاتصال بقاعدة البيانات",
    activated_successfully: "تم تفعيل الترخيص بنجاح",
    license_activated_successfully: "تم تفعيل الترخيص بنجاح",
    server_error: "خطأ في السيرفر",
    error_connecting_to_verfication_server: "خطأ في الاتصال بسيرفر التحقق",
    too_many_requests_try_later:
      "تخطيت حاجز محاولات تسجيل الدخول، حاول مجددا لاحقاً",
  },
  dashboard: {
    dashboard: "الرئيسية",
    statistics: {
      total_accounts: "إحمالي الحسابات",
      online_accounts: "الحسابات المتصلة",
      expired_accounts: "الحسابات المنتهية",
      disabled_accounts: "الحسابات المعطلة",
      total_cards: "إجمالي البطاقات",
      online_cards: "البطاقات المتصلة",
      expired_cards: "البطاقات المنتهية",
      disabled_cards: "البطاقات المعطلة",
      total_users: "إجمالي المستخدمين",
      profiles: "البروفايلات",
      managers: "المدراء",
      total_online: "الجلسات المتصلة",
      more: "عرض المزيد",
      money: "الرصيد المتوفر",
      expiring_accounts: "حسابات تنتهي قريبا",
      expiring_cards: "بطاقات تنتهي قريبا",
      support_tickets: "طلبات الصيانة",
      debt_accounts: "حسابات عليها ديون",
      expiration_profile_accounts: "حسابات ضمن بروفايل الانتهاء",
      remaining_sessions: "الجلسات المتبقية",
      online_sessions: "الجلسات المتصلة",
      accounts_expiring_soon: "حسابات تنتهي قريبا",
      accounts_at_expiration_profile: "حسابات ضمن بروفايل الانتهاء",
      total_debt: "إجمالي الديون",
      user: "مستخدم",
      account: "حساب",
      card: "بطاقة",
      profile: "بروفايل",
      ticket: "طلب صيانة",
      session: "جلسة",
      online: "المتصلين",
      top_10_profiles: "أعلى 10 بروفايلات",
      online_admins: "المدراء المتصلين",
      online_resellers: "الوكلاء المتصلين",
      today: "اليوم",
      month: "هذا الشهر",
      shamcash_bills: "تحصيلات شام كاش",
    },
    time: {
      uptime: "زمن التشغيل",
      version: "الإصدار",
    },
    gauges: {
      memory: "الذاكرة",
      cpu: "المعالج",
      disk: "القرص الصلب",
      uptime: "زمن التشغيل",
      voltage: "الفولت",
      cpu_temp: "حرارة المعالج",
    },
    daily: {
      daily_users: "مستخدم نشط يومياً",
    },
    earnings: {
      today_earnings: "جدول اليوم",
      week_earnings: "جدول الاسبوع",
      month_earnings: "جدول الشهر",
      year_earnings: "جدول السنة",
      grand_total: "المجموع الكلي",
      amount: "المبلغ",
      bills_count: "عدد الفواتير ",
      my_earnings: "شخصي",
      admins: "مدراء",
      resellers: "وكلاء",
      shamcash: "شام كاش",
      app_money: "محفظة التطبيق",
      total_paid: "مجموع المقبوضات",
      total_debt: "مجموع الديون",
      amount_paid: "المبلغ المقبوض",
      amount_debt: "المبلغ المديون",
      earnings: "مقبوضات",
      debts: "ديون",
    },
    logins: "تسجيل دخول",
    new_users: "مستخدم جديد",
    api_disconnected: "API غير متصل",
    check_api_connection_with_network: "من فضلك تحقق من اتصال API مع الشبكة",
    ping_timeout: "لا يوجد اتصال مع الشبكة",
    check_connection_with_network: "من فضلك تحقق من الاتصال مع الشبكة",
  },
  accounts: {
    id: "رقم التعريف",
    account: "حساب",
    accounts: "الحسابات",
    auto_update: "تحديث تلقائي",
    add_account: "إضافة حساب",
    edit_account: "تعديل حساب",
    first_name: "الاسم",
    last_name: "الكنية",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    email: "البريد الإلكتروني",
    phone: "رقم الجوال",
    phone_line: "رقم الهاتف الارضي",
    address: "العنوان",
    profile: "البروفايل",
    ip_address: "عنوان الايبي",
    expires_at: "ينتهي في",
    sessions: "عدد الاجهزة المسموحة للاتصال",
    used_quota: "الحزمة المستهلكة",
    status: "الحالة",
    connection: "الاتصال",
    notes: "ملاحظات",
    has_ip: "ايبي مثبت",
    has_ip_false: "ايبي تلقائي",
    has_expire_profile: "يوجد بروفايل نهاية خدمة",
    has_expire_profile_false: "لا يوجد بروفايل نهاية خدمة",
    has_fixed_expiration: "تاريخ الانتهاء",
    record_sessions: "حفظ جلسات الاتصال",
    record_sessions_false: "مسح جلسات الاتصال",
    expire_profile: "بروفايل نهاية الخدمة",
    auto_renew: "تجديد إشتراك تلقائي",
    auto_renew_false: "تجديد إشتراك يدوي",
    add_account: "إضافة حساب",
    save: "حفظ",
    cancel: "إلغاء",
    details: "تفاصيل الحساب",
    general: "معلومات عامة",
    full_name: "الاسم الكامل",
    last_seen: "توقيت اخر اتصال",
    debts: "الديون",
    paid: "مدفوع",
    paid_false: "غير مدفوع",
    expired_since: "منته منذ",
    is_mac: "تثبيت تسجيل الدخول لماك واحد فقط",
    mac_address: "عنوان الماك المثبت",
    paid_at: "تاريخ دفع الفاتورة",
    next_profile: "البروفايل التالي عند انتهاء الاصلي",
    serial_number: "الرقم التسلسلي",
    money: {
      title: "تعديل الرصيد",
      money: "الرصيد",
      current: "الرصيد الحالي",
      deposit: "إيداع",
      withdraw: "سحب",
      current_balance: "الرصيد الحالي",
    },
    delete_all_bills: "حذف جميع الفواتير",
    delete_all_sessions: "حذف جميع الجلسات",
    temp_speed: {
      title: "تعديل سرعة حساب بشكل مؤقت",
      default_speed: "السرعة الافتراضية",
      new_speed: "السرعة الجديدة",
      note:
        "يتم تطبيق السرعة الجدية حتى ينتهي الوقت او يقوم الحساب بتسجيل الخروج ثم تعود السرعة الافتراضية",
      apply: "تطبيق",
      session_time: "وقت الجلسة (دقيقة)",
    },
    personal_info: "المعلومات الشخصية",
    add_personal_info: "إضافة معلومات شخصية",
    account_details: "تفاصيل الحساب",
    add_account_details: "إضافة تفاصيل الحساب",
    ip_port_info: "معلومات IP و Port",
    add_ip_port_info: "إضافة معلومات IP و Port",
    other_info: "معلومات أخرى",
    add_other_info: "إضافة معلومات أخرى",
    enter_personal_info: "قم بإدخال المعلومات الشخصية",
    renew: "التجديد",
    auto_renew: "تجديد تلقائي",
    manual_renew: "تجديد يدوي",
    pool_name: "اسم مجموعة الايبي",
    public_ip: "عنوان IP العام",
    national_id: "الرقم الوطني",
    expiration: "ينتهي في",
    father_name: "اسم الأب",
    mother_name: "اسم الأم",
    map_coordinates: "إحداثيات الخريطة",
    edit_general_information: "تعديل المعلومات العامة",
    deactivate_account: "تعطيل الحساب",
    delete_account_permanently: "حذف الحساب نهائيا",
    change_subscription: "تغيير الاشتراك",
    renew_type: "نوع التجديد",
    add_2_free_days: "إضافة يومين مجانا",
    temporary_speed_change: "تغيير السرعة مؤقتا",
    disconnect: "قطع الاتصال",
    reseller: "الوكيل",
    allowed_devices: "عدد الاجهزة المسموحة",
    edit_account_details: "تعديل تفاصيل الحساب",
    days_remaining: "عدد الأيام المتبقية",
    mbps: "مب/ثا",
    kbs: "كب/ثا",
    select_reseller: "اختر الوكيل",
    subscription: "الاشتراك",
    bills: "الفواتير",
    alerts: "الاشعارات",
    support_tickets: "الدعم الفني",
    sessions: "الجلسات",
    usage: "الاستهلاك",
    location: "الموقع",
    open_in_google_maps: "فتح في خرائط جوجل",
    live_speed_chart: "مخطط السرعة الحالي",
    traffic_usage_chart: "مخطط استهلاك البيانات",
    renew_subscription: "تجديد الاشتراك",
    unit: {
      months: "شهر",
      days: "يوم",
      hours: "ساعة",
    },
    days_of: (ctx) => `${ctx.named("days")} من ${ctx.named("total")} يوم`,
    mega_of: (ctx) => `${ctx.named("used")} من ${ctx.named("total")}`,
    this_will_deactivate_account_temporarily: `سوف يتسبب هذا في تعطيل الحساب بشكل مؤقت. لن يتمكن المستخدم من تسجيل الدخول حتى يتم إعادة تنشيطه.`,
    yes_deactivate: `نعم، تعطيل الحساب`,
    deactivate: `تعطيل`,
    the_account_has_been_deactivated: `تم تعطيل الحساب بنجاح`,
    this_will_delete_account_permanently: `سوف يتسبب هذا في حذف الحساب نهائيا. لن يتمكن المستخدم من تسجيل الدخول مرة أخرى ولن تتمكن من الوصول إلى الحساب مجدداً.`,
    the_account_has_been_permanently_deleted: `تم حذف الحساب بشكل نهائي بنجاح`,
    this_will_delete_all_bills_permanently: "سيتم حذف جميع الفواتير بشكل نهائي",
    all_bills_have_been_deleted: "تم حذف جميع الفواتير",
    this_will_delete_all_sessions_permanently:
      "سيتم حذف جميع الجلسات ما عدا المتصلة بشكل نهائي",
    all_sessions_have_been_deleted: "تم حذف جميع الجلسات",
    this_will_disconnect_the_user_from_the_internet:
      "سيتم قطع اتصال المستخدم بالانترنت",
    yes_disconnect: "نعم, قطع الاتصال",
    the_user_has_been_disconnected_from_the_internet:
      "تم قطع اتصال المستخدم بالانترنت",
    this_will_set_the_subscription_to_manual_renewal:
      "سيتم ضبط الاشتراك على التجديد اليدوي",
    yes_set_manual: "نعم, ضبط يدوي",
    suscription_is_now_set_to_manual_renewal:
      "تم ضبط الاشتراك على التجديد اليدوي",
    this_will_set_the_subscription_to_auto_renewal:
      "سيتم ضبط الاشتراك على التجديد التلقائي",
    yes_set_auto: "نعم, ضبط تلقائي",
    susbcription_is_now_set_to_auto_renewal:
      "تم ضبط الاشتراك على التجديد التلقائي",
    add_2_free_days: "إضافة يومين مجاناً",
    yes_add_2_days: "نعم, اضافة يومين",
    yes_add_3_days: "نعم, تفعيل ومهلة 3 ايام",
    two_free_days_added_to_the_subscription: "تم إضافة يومين مجاناً للاشتراك",
    this_will_add_2_free_days_to_the_subscription:
      "سيتم إضافة يومين مجاناً للاشتراك وتغيير تاريخ الانتهاء",
    speed_updated_temporarily: "تم تحديث السرعة مؤقتاً بنجاح",
    error_while_changing_speed: "خطأ أثناء تغيير السرعة",
    duration: "المدة",
    hours: "ساعة",
    temp_download_speed: "سرعة التحميل (ميغا)",
    temp_upload_speed: "سرعة الرفع (ميغا)",
    current_subscription: "الاشتراك الحالي",
    select_subscription: "اختر الاشتراك",
    next_subscription: "الاشتراك التالي",
    select_next_subscription: "اختر الاشتراك التالي",
    yes_delete_it: "نعم, احذف",
    deactivated: "معطل",
    this_will_reactivate_account: `سيؤدي هذا إلى إعادة تنشيط الحساب. سيتمكن المستخدم من تسجيل الدخول مرة أخرى.`,
    yes_activate: `نعم, إعادة تنشيط الحساب`,
    account_has_been_reactivated: `تم إعادة تنشيط الحساب بنجاح`,
    reactivate_account: "إعادة تفعيل الحساب",
    activated: "تم التفعيل",
    new_expires_at: "تاريخ الانتهاء الجديد",
    renew: "تجديد",
    account_has_been_renewed_successfully: "تم تجديد الحساب بنجاح",
    usage_filters: {
      today: "اليوم",
      yesterday: "أمس",
      this_week: "هذا الأسبوع",
      this_month: "هذا الشهر",
      last_month: "الشهر الماضي",
      this_year: "هذا العام",
    },
    edit_location: "تعديل الموقع",
    add_2_temp_days: "مهلة 2 ايام للدفع",
    add_3_temp_days: "تفعيل الحساب ومهلة 3 ايام للدفع",
    this_will_add_3_temp_days_to_the_subscription: `سيؤدي هذا إلى تفعيل الحساب من تاريخ اليوم ومهلة الحساب 3 ايام للدفع من رصيده.`,
    this_will_add_2_temp_days_to_the_subscription: `سيؤدي هذا إلى مهلة الحساب 2 ايام للدفع من رصيده.`,
    two_temp_days_added_to_the_subscription: `تمت مهلة الاشتراك 2 ايام للدفع بنجاح.`,
    three_temp_days_added_to_the_subscription: `تم التفعيل ومهلة الاشتراك 3 ايام للدفع بنجاح.`,
    this_will_delete_all_selected_accounts_permanently: `سوف يقوم هذا بحذف جميع الحسابات المحددة نهائيا ولن تتمكن من استرجاعها`,
    selected_accounts_has_been_deleted: "تم حذف الحسابات المحددة",
    this_will_disable_all_selected_accounts:
      "سيؤدي هذا إلى تعطيل جميع الحسابات المحددة",
    selected_accounts_has_been_disabled: "تم تعطيل الحسابات المحددة بنجاح",
    this_will_disconnect_all_selected_accounts:
      "سيؤدي هذا إلى قطع اتصال جميع الحسابات المحددة",
    selected_accounts_has_been_disconnected: "تم قطع اتصال الحسابات المحددة",
    this_will_add_48h_temporarily_to_all_selected_accounts:
      "سيؤدي هذا إلى مهلة 2 ايام للحسابات المحددة",
    this_will_add_72h_temporarily_to_all_selected_accounts:
      "سيؤدي هذا إلى تفعيل ومهلة 3 ايام للحسابات المحددة",
    added_temp_48h_to_selected_accounts:
      "تمت مهلة 2 ايام جميع الحسابات المحددة",
    added_temp_72h_to_selected_accounts:
      "تمت مهلة 3 ايام جميع الحسابات المحددة",
    this_will_add_free_48h_to_all_selected_accounts:
      "سيؤدي هذا إلى إضافة 3 ايام مجانية إلى جميع الحسابات المحددة",
    added_free_48h_to_selected_accounts:
      "تمت إضافة 3 ايام مجانية إلى جميع الحسابات المحددة",
    country: "البلد",
    state: "المحافظة",
    city: "المدينة",
    neighborhood: "الحي",
    street: "الشارع",
    address_details: "تفاصيل الموقع",
    ex_apartment_number: "مثال: رقم الشقة",
    deposit_date: "تاريخ الإيداع",
    withdraw_date: "تاريخ السحب",
    amount: "المبلغ",
    print_bill: "طباعة الفاتورة",
    close: "إغلاق",
    edit_accounts_expirations: "تعديل تاريخ انتهاء مجموعة حسابات",
    date_required: "تاريخ الانتهاء مطلوب",
    accounts_expiration_updated: "تم تحديث تاريخ انتهاء الحسابات بنجاح",
    gps_coordinates: "إحداثيات GPS",
    connected_ip_address: "عنوان الايبي المتصل",
    used_quota_value: "قيمة الحزمة المستهلكة",
    edit_accounts_profiles: "تعديل بروفايل مجموعة حسابات",
    accounts_profiles_updated: "تم تغيير بروفايل مجموعة حسابات",
    minutes: "دقيقة",
    show_more: "عرض المزيد",
    show_less: "عرض أقل",
    clear_sessions: "مسح الجلسات",
    delete_account_sessions: "حذف جلسات الحساب",
    this_will_delete_all_account_sessions_and_reset_quota_usage: `سيؤدي هذا إلى حذف جميع جلسات الحساب وتصفير استهلاك الحزمة.`,
    yes_clear_sessions: "نعم، مسح الجلسات",
    account_sessions_have_been_cleared: "تم مسح جلسات الحساب بنجاح",
    this_will_delete_all_selected_accounts_sessions_permanently: `سيؤدي هذا إلى حذف جميع جلسات واستهلاك الحسابات المحددة نهائيا ولن تتمكن من استرجاعها`,
    selected_accounts_sessions_has_been_deleted:
      "تم حذف جلسات الحسابات المحددة",
    days_expired: "ايام منتهي",
    traffic_limit_reached: "تم الوصول إلى حد الاستهلاك",
    total_paid: "المدفوعات",
    this_will_enable_all_selected_accounts: `سيؤدي هذا إلى  تفعيل جميع الحسابات المحددة`,
    yes_enable: `نعم، تفعيل الحسابات`,
    selected_accounts_has_been_enabled: "تم تفعيل الحسابات المحددة بنجاح",
    enabled: "تم التفعيل",
    short: {
      next_profile: "البروفايل التالي",
    },
    shamcash_code: "رمز دفع شام كاش",
    last_connect_time: "توقيت اخر اتصال",
    last_disconnect_time: "توقيت اخر قطع اتصال",
    last_seen_online: "اخر مشاهدة اونلاين",
    operation_cost: "تكلفة العملية",
    money_left: "الرصيد المتبقي",
    private_ip_address: "IP الخاص",
    public_ip_address: "IP العام",
    id_image_front: "صورة الهوية (الجهة الأمامية)",
    id_image_back: "صورة الهوية (الجهة الخلفية)",
    national_id_image: "صورة الهوية الوطنية",
    front_side: "الوجه",
    rear_side: "الخلف",
    renew_manual_temp: "مهلة محددة يدويا",
    enter_temp_days: "أدخل عدد أيام المهلة",
    temp_renew_days_count: "عدد أيام المهلة المحددة",
    temp_renew_days_count_required: "عدد أيام المهلة مطلوب",
    added_temp_temp_days_to_selected_accounts:
      "تمت إضافة مهلة الأيام المحددة لجميع الحسابات المحددة",
    delete_custom_speed: "إلغاء تعديل السرعة",
    this_will_delete_custom_speed_and_return_to_normal:
      "سيؤدي هذا إلى الغاء تعديل السرعة والعودة إلى سرعة البروفايل الاصلية",
    speed_returned_to_normal: "تمت اعادة السرعة الافتراضية",
    print_contract: "طباعة عقد الاشتراك",
    operations_log: "سجل العمليات",
    click_to_open: "انقر لبدء محادثة",
    documents: "المستندات",
    sales_debts: "ديون المبيعات",
  },
  online: {
    online_customers: "الحسابات المتصلة",
    auto_update: "تحديث تلقائي",
    username: "إسم المستخدم",
    name: "الاسم",
    profile: "البروفايل",
    mac_address: "العنوان الفيزيائي",
    ip_address: "عنوان الايبي",
    type: "النوع",
    traffic_used: "الاستهلاك",
    usage: "الاستهلاك",
    uptime: "مدة الاتصال",
    network: "شبكة الاتصال",
    interface: "الانترفيس",
    from: "المصدر",
    start_date: "توقيت البدء",
    stop_date: "توقيت التوقف",
    stop_cause: "سبب التوقف",
    session_duration: "مدة الجلسة",
    connect_time: "توقيت الاتصال",
    disconnect_time: "توقيت قطع الاتصال",
    sum: "مجموع الاستهلاك",
    range_date: "تحديد فترة زمنية",
    truncate: {
      title: "تنظيف الجلسات القديمة",
      end_date: "مسح الجلسات قبل تاريخ محدد",
      only: "مسح الجسات لـ:",
      all: "حسابات وبطاقات",
      cards_only: "بطاقات فقط",
      accounts_only: "حسابات فقط",
      warning_cards:
        "تحذير! مسح الجلسات للبطاقات الغير منتهية التاريخ يتسبب في اعادة تمكين استخدامها.",
      truncate: "تأكيد المسح",
      confirm: "هل انت متأكد من مسح الجلسات",
      before_3months: "يجب ان يكون التاريخ قبل 3 اشهر على الاقل",
      before_must_be_at_least_1month: "يجب ان يكون التاريخ قبل شهر على الاقل",
      warining_this_will_take_long_time:
        "تحذير: قد تستغرق العملية وقتاً طويلاً",
      sessions_cleared_successfully: "تم مسح الجلسات بنجاح",
    },
    sessions_columns: "أعمدة الجلسات",
    status: "الحالة",
    protocol: "البروتوكول",
    delete_all_sessions: "حذف جميع الجلسات",
    this_will_disconnect_selected_sessions_from_the_internet:
      "سيؤدي هذا إلى قطع اتصال الجلسات المحددة بالانترنت",
    sum_time: "مجموع الوقت",
    account_name: "الاسم والكنية",
    clear_all: "مسح جميع الجلسات المتصلة",
    this_will_clear_all_online_sessions_from_radius_only:
      "سيؤدي هذا إلى تغيير حالة جميع الجلسات إلى غير متصل في الراديوس فقط",
    yes_clear: "نعم امسح",
    online_sessions_has_been_cleared: "تم مسح جميع الجلسات المتصلة",
  },
  profiles: {
    profile: "البروفايل",
    auto_update: "تحديث تلقائي",
    name: "الاسم",
    enabled: "مفعل",
    disabled: "معطل",
    service: "الخدمة",
    type: "النوع",
    price: "السعر",
    speed_limit: "السرعة",
    expiration: "الانتهاء",
    quota: "الاستهلاك المسموح",
    ip_pool: "Mikrotik IP Pool",
    total_accounts: "عدد الحسابات",
    online_accounts: "الحسابات المتصلة",
    allowed_nases: "الشبكات المسموحة",
    add_profile: "إضافة بروفايل",
    edit_profile: "تعديل بروفايل",
    connection_speed: "سرعة الاتصال:",
    download_speed: "سرعة التحميل",
    upload_speed: "سرعة الرفع",
    expiration_date: "تاريخ إنتهاء محدد",
    expiration_date_false: "تاريخ إنتهاء غير محدد",
    limited_quota: "استهلاك محدد",
    limited_quota_false: "استهلاك غير محدود",
    shared: "بروفايل تشاركي",
    shared_false: "بروفايل غير تشاركي",
    shared_note:
      "تفعيل هذا الخيار يضيف سكريبت تشاركي على الميكروتيك بشكل تلقائي",
    shared_download_speed: "التحميل التشاركي",
    shared_upload_speed: "الرفع التشاركي",
    custom_attributes: "سمات مخصصة",
    resellers_allowed_sessions: "(خاص بالوكلاء) عدد الأجهزة المسموحة",
    open_speed: "فتح سرعة البروفايل",
    start_hour: "وقت البدء",
    stop_hour: "وقت التوقف",
    open_download: "سرعة التحميل المفتوحة (ميغا)",
    open_upload: "سرعة الرفع المفتوحة (ميغا)",
    select_nas: "اختر شبكة",
    unlimited_speed: "سرعة غير محدودة",
    unlimited_speed_false: "سرعة محدودة",
    expiration_profile: "بروفايل انتهاء الخدمة",
    expiration_profile_note:
      "تفعيل هذا الخيار يضيف مجال ايبي على الميكروتيك بشكل تلقائي ويقوم بعرض صفحة انتهاء الاشتراك عند انتهاء اشتراك الحساب",
    expiration_profile_message: "رسالة الانتهاء",
    next_profile: "البروفايل التالي",
    unit: {
      unit: "الواحدة",
      days: "أيام",
      months: "أشهر",
      hours: "ساعات",
    },
    units: {
      days: "يوم",
      months: "شهر",
      hours: "ساعة",
    },
    add: "إضافة",
    save: "حفظ",
    cancel: "إلغاء",
    renew: {
      title: "تجديد إشتراك حساب",
      accounts_title: "تثبيت تاريخ انتهاء حسابات البروفايل",
      amount: "عدد مرات الإضافة",
      renew: "تجديد",
      confirm: "هل انت متأكد من تجديد الحساب حتى التاريخ المحدد أعلاه ؟",
      accounts_confirm:
        "هل انت متأكد من تجديد جميع حسابات البروفايل حتى التاريخ المحدد أعلاه ؟",
      payment_status: "حالة الدفع",
      paid: "مدفوع",
      in_debt: "غير مدفوع",
      debt_confirm: "بدون دفع التكلفة؟",
      paid_debt_confirm: "بدون دفع كامل التكلفة؟",
      discount: "الخصم",
      paid_amount: "المبلغ المدفوع",
    },
    change_profile_values: {
      details: "تفاصيل تغيير البروفايل",
      old_price: "سعر البروفايل الحالي",
      new_price: "سعر البروفايل الجديد",
      billed_days: "الايام المتبقية لانتهاء البروفايل الحالي",
      new_days: "الايام الجديدة المضافة",
      billed_days_price: "تكلفة تغيير بروفايل الايام المتبقية",
      new_days_price: "تكلفة الايام الجديدة المضافة",
    },
    app_allowed: "مسموح في التطبيق",
    app_allowed_false: "غير مسموح في التطبيق",
    app_allowed_note:
      "مسموح للاستخدام في التطبيق ليقوم المستخدم بالتجديد يدويا عن طريق الرصيد",
    profiles_columns: "أعمدة البروفايلات",
    subscription: "اشتراك",
    prepaid: "بطاقات",
    status: "الحالة",
    allowed_admins: "مرئي للمدراء",
    keep_old_expiration_date: "المحافظة على تاريخ الانتهاء القديم",
    add_days: "إضافة أيام مع تغيير البروفايل",
    general_info: "معلومات عامة",
    add_general_info: "إضافة معلومات عامة",
    profile_details: "تفاصيل البروفايل",
    setup_profile_details: "إعداد تفاصيل البروفايل",
    other_info: "معلومات أخرى",
    add_more_info: "إضافة معلومات أخرى",
    limited_speed: "سرعة محددة",
    delete_profile_permanently: "حذف البروفايل بشكل نهائي",
    this_will_delete_profile_permanently_and_all_accounts_and_cards_connected_to_it_you_wont_be_able_to_get_them_back:
      "سيؤدي هذا إلى حذف البروفايل بالاضافة إلى جميع الحسابات والبطاقات المرتبطة معه ولن تتمكن من استعادتهم",
    yes_am_sure_delete_them: "نعم، انا متأكد قم بالحذف",
    profile_has_been_deleted_successfully: "تم حذف البروفايل بنجاح",
    disable_profile_temporarily: "تعطيل بروفايل بشكل مؤقت",
    this_will_disable_profile_until_you_renable_it:
      "سيؤدي هذا إلى تعطيل البروفايل حتى تقوم بإعادة تفعيله",
    profile_disabled: "تم تعطيل البروفايل",
    enable_profile: "تفعيل بروفايل",
    this_will_enable_profile: "سيؤدي هذا إلى إعادة تفعيل البروفايل",
    profile_enabled: "تم تفعيل البروفايل",
    description: "الوصف",
  },
  batches: {
    auto_update: "تحديث تلقائي",
    add_cards: "إضافة بطاقات",
    generate_cards: "توليد بطاقات",
    name: "الاسم",
    quantity: "الكمية",
    price: "السعر",
    prefix: "السابقة",
    profile: "البروفايل",
    username_length: "طول اسم المستخدم",
    password_length: "طول كلمة المرور",
    sessions: "عدد الاجهزة",
    allowed_sessions: "عدد الاجهزة المسموحة",
    created_at: "تاريخ الإنشاء",
    chars: "نمط المحارف",
    alpha: "أحرف وأرقام",
    numeric: "أرقام فقط",
    add: "توليد",
    save: "حفظ",
    cancel: "إلغاء",
    print: "طباعة",
    print_cards: "طباعة بطاقات",
    logo: "شعار الشبكة",
    network: "اسم الشبكة",
    horiz: "الوضع الافقي",
    cards_count: "عدد البطاقات",
    cards_count_row: "عدد البطاقات في كل سطر",
    speed: "السرعة",
    duration: "المدة",
    quota: "الإستهلاك",
    color_border: "الإطار",
    color_background: "الخلفية",
    color_text_big: "النص الاساسي",
    color_text_small: "النص الثانوي",
    color_input: "المربعات الاساسية",
    color_boxes: "المربعات الثانوية",
    add_background: "إضافة خلفية",
    username_password: "اسم المستخدم وكلمة المرور",
    truncate: "حذف جميع البطاقات المنتهية",
    designer: "نمط التصميم",
    basic_designer: "بسيط",
    advanced_designer: "متقدم",
    saved_designs: "التصميمات المحفوظة",
    design_name: "اسم التصميم",
    new_design: "تصميم جديد",
    resize: "التصغير من هنا",
    fresh_cards: "بطاقات غير مستخدمة",
    is_mac: "تسجيل الدخول لماك واحد فقط",
    cards_groups_columns: "اعمدة مجموعات البطاقات",
    not_used_cards: "بطاقات غير مستخدمة",
    allow_only_one_mac_address: "تسجيل الدخول لماك واحد فقط",
    generate_cards: "توليد بطاقات",
    save_design: "حفظ التصميم",
    upload_background: "رفع خلفية",
    remove_background: "حذف الخلفية",
    color: "اللون",
    position: "الموقع",
    one_card_per_line: "بطاقة واحدة في كل سطر",
    two_cards_per_line: "بطاقتين في كل سطر",
    three_cards_per_line: "ثلاث بطاقات في كل سطر",
    enter_new_design_name: "ادخل اسم التصميم الجديد",
    design_name: "اسم التصميم",
    design_name_required: "اسم التصميم مطلوب",
    new_design_saved: "تم حفظ التصميم الجديد",
    delete_batch_permanently: "حذف مجموعة البطاقات بشكل نهائي",
    this_will_delete_batch_and_all_its_cards_permanently:
      "سيؤدي هذا إلى حذف جميع بطاقات هذه المجموعة بشكل نهائي",
    batch_has_been_permanently_delete: "تم حذفة المجموعة بشكل نهائي",
    one_card_price: "سعر البطاقة",
    paid_cards: "البطاقات المباعة",
    paid_cards_percentage: "نسبة البطاقات المباعة",
    total_price: "المبلغ الاجمالي",
    total_payments: "اجمالي المبيعات",
    batch: "المجموعة",
  },
  cards: {
    card: "بطاقة",
    auto_update: "تحديث تلقائي",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    used: "مستعمل",
    profile: "البروفايل",
    batch: "الحزمة",
    expires_at: "تاريخ الإنتهاء",
    used_quota: "الحزمة المستهلكة",
    status: "الحالة",
    connection: "الإتصال",
    details: "تفاصيل البطاقة",
    cards_columns: "أعمدة البطاقات",
    remove_expired_cards: "حذف البطاقات المنتهية",
    this_will_delete_all_expired_cards_from_system:
      "سيؤدي هذا إلى حذف جميع البطاقات المنتهية من النظام، لن تتمكن من التراجع عن الحذف",
    yes_delete_cards: "نعم، حذف البطاقات",
    removed_expired_cards: "تم حذف البطاقات المنتهية",
    this_will_delete_all_selected_cards_from_system:
      "سيؤدي هذا إلى حذف البطاقات المحددة من النظام بشكل نهائي",
    yes_delete_cards: "نعم، حذف البطاقات",
    deleted_cards: "تم حذف البطاقات",
    this_will_disable_card_and_prevent_it_from_using_internet:
      "سيؤدي هذا إلى تعطيل البطاقة وإيقاف إمكانية اتصالها بالانترنت",
    card_disabled: "تم تعطيل البطاقة",
    this_will_enable_card_and_return_it_to_using_internet:
      "سيؤدي هذا إلى تفعيل البطاقة واستعادة امكانية اتصالها بالانترنت",
    card_enabled: "تم تفعيل البطاقة",
    this_will_disconnect_card_from_internet:
      "سيؤدي هذا إلى قطع اتصال البطاقة عن الانترنت",
    card_disconnected: "تم قطع اتصال البطاقة",
    this_will_delete_all_card_sessions: "سيؤدي هذا إلى حذف جميع جلسات البطاقة",
    card_session_cleared: "تم مسح جلسات البطاقة",
    allowed_sessions: "عدد الاجهزة المسموحة",
    used_quota_value: "قيمة الحزمة المستهلكة",
  },
  admins: {
    auto_update: "تحديث تلقائي",
    add_admins: "إضافة مدراء",
    add_admin: "إضافة مدير",
    edit_admins: "تعديل الحساب",
    first_name: "الاسم",
    last_name: "الكنية",
    email: "اسم المستخدم",
    password: "كلمة المرور",
    phone: "الهاتف",
    privileges: "الصلاحيات",
    allowed_nases: "الشبكات المسموحة",
    allowed_profiles: "البروفايلات المسموحة",
    change: "تغيير",
    cancel: "إلغاء",
    save: "حفظ",
    add: "إضافة",
    enable_all: "تفعيل الكل",
    disable_all: "إلغاء الكل",
    add_resellers: "إضافة وكلاء",
    money: "الرصيد",
    prefix: "السابقة",
    type: "النوع",
    custom_network_logo: "شعار شبكة مخصص",
    custom_network_name: "اسم شبكة مخصص",
    signature: "التوقيع",
    photo: "الصورة",
    add_reseller: "إضافة وكيل",
    credit: "الرصيد",
    admins_colums: "أعمدة المدراء",
    resellers_columns: "أعمدة الوكلاء",
    general_info: "المعلومات الاساسية",
    add_general_info: "إضافة المعلومات الاساسية",
    upload_new_photo: "رفع صورة جديدة",
    reset: "مسح",
    allowed_jpg_png_max_2M: "الحد الاعلى المسموح 2m jpg, png",
    network_details: "تفاصيل الشبكة",
    setup_network_details: "إضافة تفاصيل الشبكة الخاصة",
    choose_privileges: "اختيار الصلاحيات",
    admin: "مدير",
    sysadmin: "مسؤول النظام",
    reseller: "وكيل",
    deposit: "إيداع رصيد",
    withdraw: "سحب رصيد",
    deposited_successfully: "تم إيداع الرصيد بنجاح",
    go_to_bill: "عرض الفاتورة",
    withdrawed_successfully: "تم سحب الرصيد بنجاح",
    this_will_delete_all_selected_resellers_permanently:
      "سيؤدي هذا إلى حذف الوكلاء المحددين نهائيا من النظام ولن تتمكن من استعادتهم",
    selected_resellers_have_been_deleted: "تم حذف الوكلاء المحددين بنجاح",
    this_will_delete_reseller_permanently:
      "سيؤدي هذا إلى حذف الوكيل نهائياً ولن تتمكن من التراجع",
    reseller_deleted_successfully: "تم حذف الوكيل بنجاح",
    this_will_delete_bill_and_return_credit:
      "سيؤدي هذا إلى حذف الفاتورة واستعادة الرصيد",
    benefit_rate: "نسبة الربح",
    connection_status: "حالة الاتصال",
    privileges_group: "مجموعة الصلاحيات",
    reseller_bill: "فاتورة وكيل",
    this_will_delete_all_selected_admins_permanently:
      "سيؤدي هذا إلى حذف المدراء المحددين نهائيا من النظام ولن تتمكن من استعادتهم",
    selected_admins_have_been_deleted: "تم حذف المدراء المحددين بنجاح",
    this_will_delete_admin_permanently:
      "سيؤدي هذا إلى حذف المدير نهائياً ولن تتمكن من التراجع",
    admin_deleted_successfully: "تم حذف المدير بنجاح",
    belongs_to: "يتبع إلى",
  },
  groups: {
    add_privileges_group: "إضافة مجموعة صلاحيات",
    edit_privileges_group: "تعديل مجموعة صلاحيات",
    name: "الاسم",
    privileges: "الصلاحيات",
    type: "النوع",
    name_required: "الاسم مطلوب",
    privileges_required: "الصلاحيات مطلوبة",
    admins: "مدراء",
    resellers: "وكلاء",
    privileges: "الصلاحيات",
    save: "حفظ",
    add: "إضافة",
    description: "الوصف",
    delete_privileges_group_permanently: "حذف مجموعة صلاحيات بشكل نهائي",
    this_will_delete_privileges_group_permanently_and_related_user_will_lose_privileges:
      "سيؤدي هذا إلى حذف مجموعة الصلاحيات بشكل نهائي، وسيتم فقدان الصلاحيات المرتبطة بها من قبل المستخدمين",
    yes_delete_it: "نعم، احذف",
    privileges_group_deleted_successfully: "تم حذف مجموعة الصلاحيات بنجاح",
    custom_privileges: "صلاحيات مخصصة",
    users: "المستخدمين",
  },
  nases: {
    auto_update: "تحديث تلقائي",
    add_device: "إضافة جهاز",
    edit_device: "تعديل جهاز",
    add_nas: "إضافة شبكة",
    name: "الاسم",
    ip: "الايبي",
    secret: "Secret",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    api_port: "بورت الدخول",
    api_username: " اسم المستخدم",
    api_password: " كلمة المرور",
    snmp_community: "SNMP Community",
    radius_secret: "Radius Secret",
    community: "Community",
    allowed_profiles: "البروفايلات المسموحة",
    allowed_admins: "مرئي للمدراء",
    connection: "معلومات الاتصال",
    login: "الربط مع ميكروتيك",
    other: "معلومات إضافية",
    privileges: "الصلاحيات",
    version: "الإصدار",
    status: "الحالة",
    api: "API",
    cancel: "إلغاء",
    save: "حفظ",
    add: "إضافة",
    settings: "الاعدادات",
    online_sessions: "الجلسات المتصلة",
    networks_columns: "اعمدة الشبكات",
    this_will_delete_all_selected_networks_permanently:
      "سيؤدي هذا إلى حذف جميع الشبكات المحددة بشكل نهائي",
    selected_accounts_have_been_deleted_successfull:
      "تم حذف الشبكات المحددة بنجاح",
    this_will_delete_network_permanently: "سيؤدي هذا إلى حذف الشبكة بشكل نهائي",
    network_has_been_deleted_successfully: "تم حذف الشبكة بنجاح",
    wa_instance: "مفتاح اشتراك واتساب",
    whatsapp_status: "حالة اتصال واتساب",
    scan_qr_code: "مسح رمز QR",
    whatsapp_code_not_found: "بانتظار كود واتساب",
    invalid_whatsapp_code: "كود واتساب خاطئ",
    link_whatsapp: "ربط واتساب",
    whatsapp_network_name: "اسم الشبكة عبر واتساب",
    export_secrets_code: "تنفيذ كود اضافة الحسابات على ميكروتيك",
    truncate_secrets_code: "تنفيذ كود مسح الحسابات من ميكروتيك",
    generate_remote_tunnel: "توليد رابط وصول عن بعد",
    tunnel_generated_successfully: "تم توليد رابط الوصول عن بعد بنجاح",
    remove_tunnel: "حذف رابط الوصول عن بعد",
    remote_tunnel: "رابط الوصول عن بعد",
    tunnel_removed_successfully: "تم حذف رابط الوصول عن بعد بنجاح",
    tunnel_remove_failed: "فشل حذف رابط الوصول عن بعد",
    disconnect_all: "قطع اتصال جميع الحسابات",
  },
  settings: {
    change_settings: "تغيير الإعدادات",
    change_logo: "تغيير الشعار",
    network_name: "اسم الشبكة",
    time_zone: "المنطقة الزمنية",
    currency: "العملة",
    default_language: "اللغة الإفتراضية",
    cancel: "إلغاء",
    save: "حفظ",
    add: "إضافة",
    apply: "تطبيق",
    applied: "تم التطبيق",
    auto_backup: "نسخ احتياطي تلقائي",
    default_expiration_hour: "التوقيت الافتراضي لانتهاء الحسابات",
    system: "اعدادات النظام",
    ssra: "اعدادات تطبيق الجوال",
    ssr_account_password_change: "يمكن للحسابات تغيير كلمة المرور",
    ssr_account_profile_update:
      "يمكن للحسابات تجديد البروفايل باستخدام الرصيد المتاح",
    reset: {
      reset_db_info: "اعادة ضبظ قواعدالبيانات إلى الاعدادت الافتراضية",
      reset_db_confirm:
        "هل انت متأكد من إعادة ضبط قواعد البيانات؟ سوف يتم مسح جميع البيانات بما فيها الحسابات والبطاقات وسجلات الاستهلاك والعودة إلى بيانات تسجيل الدخول الافتراضية",
      resetting_db: "جار اعادة ضبط قواعد البيانات...",
      reset: "اعادة ضبط",
    },
    phone_number: "رقم التواصل",
    status_url: "رابط صفحة الرصيد",
    nas: "اعدادت Mikrotik",
    nas_interim_update: "زمن تبادل قيم الاستهلاك مع راديوس",
    resellers: "اعدادت الوكلاء",
    benefit_rate: "نسبة الربح %",
    upload_new_logo: "تحميل شعار جديد",
    allowed_jpg_svg_png: "مسموح فقط jpg, png",
    network_name: "اسم الشبكة",
    time_zone: "المنطقة الزمنية",
    currency: "العملة",
    default_language: "اللغة الافتراضية",
    auto_backup: "نسخ احتياطي تلقائي",
    default_expiration_hour: "التوقيت الافتراضي لانتهاء الحسابات",
    balance_page_url: "رابط صفحة الرصيد",
    contact_number: "رقم التواصل",
    mobile_app_settings: "اعدادات تطبيق الجوال",
    allow_password_change: "تغيير كلمة المرور",
    allow_renew_using_balance: "تجديد الاشتراك باستخدام الرصيد المتاح",
    allow_change_profile_using_balance:
      "تغيير البروفايل باستخدام الرصيد المتاح",
    mikrotik_settings: "اعدادات ميكروتيك",
    mikrotik_interim_update: "زمن تبادل قيم الاستهلاك مع راديوس",
    reseller_settings: "اعدادات الوكلاء",
    reseller_benefit_rate: "نسبة الربح %",
    save_changes: "حفظ التغييرات",
    backup_now: "نسخ احتياطي الآن",
    name: "الاسم",
    action: "الاجراء",
    download: "تحميل",
    delete: "حذف",
    file_from_dma: "نسخة من DMA",
    drop_files_or_click_to_upload: "اسحب الملفات هنا أو انقر لتحميل",
    file_from_ssr: "نسخة من SSR",
    file_extracted_from_ssr_nas: "نسخة بيانات مستخرجة من شبكة واحدة من SSR",
    import: "استيراد",
    update_license: "تحديث الترخيص",
    device: "الجهاز",
    type: "النوع",
    subscription: "الاشتراك",
    realm: "الريلم",
    full_name: "الاسم الكامل",
    name: "الاسم",
    network: "الشبكة",
    phone: "الهاتف",
    email: "البريد الالكتروني",
    expires_at: "تاريخ الانتهاء",
    plan: "الخطة",
    plan_name: "اسم الخطة",
    details: "تفاصيل الخطة",
    duration_months: "المدة (شهور)",
    online_sessions_count: "عدد الجلسات المتصلة",
    nases_count: "عدد الشبكات",
    admins_count: "عدد المدراء",
    resellers_count: "عدد الوكلاء",
    update_license: "تحديث الترخيص",
    new_update_available: "تحديث جديد متاح",
    update_name: "اسم التحديث",
    change_log: "سجل التغييرات",
    download_and_install: "تحميل وتثبيت",
    super_speed_radius_is_up_to_date: "Super Speed Radius محدث",
    uploading_file: "جار تحميل الملف",
    file_uploaded_successfully: "تم تحميل الملف بنجاح",
    file_uploaded: "تم تحميل الملف",
    file_upload_failed: "فشل تحميل الملف",
    an_error_occurred_while_uploading_file_please_try_again:
      "حدث خطأ أثناء تحميل الملف, يرجى المحاولة مرة أخرى",
    data_imported: "تم استيراد النسخة",
    data_imported_successfully: "تمت عملية الاستيراد بنجاح",
    current_version: "الإصدار الحالي",
    file_from_mikrotik: "ملف تصدير حسابات من ميكروتيك",
    print: {
      network_logo: "شعار الشبكة",
      network_name: "اسم الشبكة",
      address: "العنوان",
      phone: "الهاتف",
      phone_line: "الهاتف الارضي",
      issued_date: "تاريخ الإصدار",
      account_id: "رقم الحساب",
      bill_id: "رقم الفاتورة",
      bill_slug: "رمز الفاتورة",
      profile: "اسم الاشتراك",
      additional_print_settings: "خيارات طباعة إضافية",
      view_price_and_paid: "المبلغ والمدفوع",
      detailed_table: "جدول مفصل",
      price_only: "المبلغ فقط",
      signature: "التوقيع",
    },
    open_account_speed_3hours: "فتح سرعة الحساب (لمدة 3 ساعات)",
    open_speed_settings: "اعدادات فتح السرعة",
    double_account_speed: "مضاعفة سرعة الحساب",
    double_speed_times: "أوقات مضاعفة السرعة",
    ssradius_json_file: "ملف بيانات من SSRADIUS",
    payment_api: {
      payment_api_settings: "اعدادات بوابة الدفع",
      additional_payment_api_settings_desc:
        "يتم هنا تفعيل العنوانين المسموح لها الاتصال مع البوابة الخاصة بالدفع وتحديد المفتاح السري X-SSR-KEY الخاص بالبوابة",
      secret_key: "المفتاح السري",
      allowed_ips: "العناوين المسموحة",
      generate_new: "توليد مفتاح جديد",
    },
    contracts: {
      contract_settings: "اعدادات العقود",
      contract_settings_desc:
        "يتم هنا ضبط قيم بيانات الشركة في عقود الاشتراكات الخاصة بالشبكة",
      company_name: "اسم الشركة",
      company_speciality: "تخصص الشركة",
      license_number: "رقم الرخصة",
      license_date: "تاريخ الرخصة",
      placeholders: {
        someone_company_limited: "شركة فلان محدودة المسؤولية",
        internet_service_provider:
          "تقديم خدمات الإنترنت للعموم باستخدام الشبكات اللاسلكية (WiFi Outdoor)",
      },
      contract_text: "نص العقد",
      default: "افتراضي",
      custom: "مخصص",
    },
  },
  mikrotik: {
    titles: {
      auto_reboot: "إعادة اقلاع تلقائي",
      whatsapp_messages: "رسائل واتساب",
      whatsapp_full: "واتساب مجاني",
      protection: "حماية",
    },
    services: "خدمات ميكروتيك",
    auto_reboot: "إعادة الإقلاع يومياً عند 5 صباحا",
    whatsapp_messages_only: "رسائل واتساب مجانية فقط",
    whatsapp_full: "واتساب مجاني كامل",
    dns: "حماية من الفيروسات والموافع الإباحية",
    open_speed: "فتح جميع السرعات في أوقات محددة",
  },
  sservices: {
    service: "الخدمة",
    status: "الحالة",
    actions: "الإجراءات",
    start: "تشغيل",
    stop: "إيقاف",
    restart: "إعادة تشغيل",
    ssradius_tunnel: "اتصال SSRADIUS البعيد",
    mysql: "قواعد البيانات MySQL",
    radius: "خدمات المصادقة الرئيسية Radius",
    running: "يعمل",
    stopped: "متوقف",
    active: "يعمل",
    inactive: "متوقف",
    freeradius: "خدمات المصادقة الرئيسية Radius",
    restarted_successfully: "تمت إعادة التشغيل بنجاح",
    started_successfully: "تم التشغيل بنجاح",
    stopped_successfully: "تم الإيقاف بنجاح",
    operation_failed: "فشلت العملية",
  },
  support_tickets: {
    support_ticket: "طلب الصيانة",
    id: "رقم الطلب",
    username: "اسم المستخدم",
    issue: "المشكلة",
    phone: "الهاتف",
    address: "العنوان",
    status: "الحالة",
    notes: "ملاحظات إضافية",
    ssr_comment: "رد الدعم الفني",
    add_ticket: "إضافة طلب",
    new: "جديد",
    in_progress: "جار المعالجة",
    resolved: "تم",
    failed: "فشل",
    priority: {
      priority: "الاولوية",
      low: "منخفصة",
      normal: "متوسطة",
      high: "عالية",
    },
    notes_array: {
      router_working: "الراوتر يعمل",
      router_not_working: "الراوتر لا يعمل",
      internet_working: "الانترنت يعمل",
      no_internet: "الانترنت لا يعمل",
      active: "الحساب نشط",
      not_active: "الحساب غير نشط",
      cable_light_working: "ضوء الكابل يعمل",
      cable_light_not_working: "ضوء الكابل لا يعمل",
      restarted: "تم إعادة تشغيل",
      not_restarted: "لم يتم إعادة تشغيل",
    },
    today: "اليوم",
    support_tickets_columns: "أعمدة طلبات الدعم الفني",
    created_at: "تاريخ الإنشاء",
    this_will_delete_support_ticket: "سيؤدي هذا إلى حذف طلب الصيانة",
    support_ticket_has_been_deleted: "تم حذف طلب الصيانة",
    this_will_delete_all_selected_support_tickets:
      "سيؤدي هذا إلى حذف طلبات الصيانة المحددة",
    support_tickets_have_been_deleted: "تم حذف طلبات الصيانة",
    title: "العنوان",
    body: "النص",
    send_notification_to_account: "إرسال إشعار للحساب",
    send: "إرسال",
    notification_sent_successfully: "تم ارسال الاشعار بنجاح",
    failed_to_send_notification: "فشل إرسال الاشعار",
    both_fields_required: "يجب ادخال قيمة للحقلين",
  },
  notifications: {
    title: "العنوان",
    notification_text: "نص الإشعار",
    receiver: "المستقبل",
    sender: "المرسل",
    image: "الصورة",
    status: "الحالة",
    created_at: "تاريخ الارسال",
    show_archived: "عرض المؤرشفة",
    new_notification: "إشعار جديد",
    archived: "مؤرشف",
    new: "جديد",
    error: "لايمكن ترك خانة فارغة",
    push: "إرسال الإشعار",
    confirm: "هل انت متأكد من إرسال الإشعار إلى الوجهة المحددة؟",
    notified_at: "تاريخ الإشعار",
    notifications_columns: "أعمدة الإشعارات",
    type: {
      type: "النوع",
      account_expiring: "قرب انتهاء حساب",
      account_expired: "انتهاء حساب",
      account_renew: "تجديد حساب",
      account: "إلى حساب",
      profile: "إلى بروفايل",
      nas: "إلى شبكة",
      ssr: "إلى الكل",
      global: "من النظام",
      support_new: "طلب صيانة جديد",
      support_in_progress: "جار معالجة طلب الصيانة",
      support_resolved: "تم حل طلب الصيانة",
      support_failed: "فشل طلب الصيانة",
      whatsapp: "رسائل واتساب",
      sms: "رسائل SMS",
      telegram: "اشعارات تيليجرام",
      search_by_username: "بحث عن الحساب بواسطة اسم المستخدم",
      search_by_profile: "بحث عن البروفايل بواسطة الاسم",
    },
    wa: {
      status: "حالة الاتصال",
      statuses: {
        authenticated: "تم الاتصال",
        qr: "بانتظار مسح الرمز",
        initialize: "تجهيز الاتصال...",
        initializing: "تجهيز الاتصال...",
        session_not_connected: "يتطلب اعادة تشغيل...",
        session_connected: "متصل",
        session_not_found: "رمز الترخيص خاطئ",
        no_instance: "بانتظار مفتاح الترخيص ",
        free: "متصل باستخدام الخدمة المجانية",
        disconnected: "تم قطع الاتصال",
      },
      session_restarted: "تم اعادة تشغيل الاتصال",
      session_restart_failed: "فشل اعادة تشغيل الاتصال",
      restart: "اعادة تشغيل الاتصال",
      subscription_key: "مفتاح الترخيص",
      validate: "ارسال المفتاح",
      scan_qr: "قم بمسح الكود باستخدام تطبيق واتساب وميزة ربط جهاز",
      refresh: "تحديث",
      license_validated: "تم التحقق من صحة المفتاح",
      license_not_valid: "المفتاح غير صالح",
    },
    tg: {
      admins_transactions_log_group: "مجموعة مراقبة العمليات المالية",
      admins_group_note: `يحب ان تقوم بإضافة البوت الخاص بنا {'@'}ssradius_transactions_bot إلى مجموعة جديدة تقوم بإنشائها لاستلام سجل العمليات عليها.`,
      admins_group_id_note: `للحصول على معرف المجموعة قم بإضافة البوت إلى المجموعة ليقوم بإظهار المعرف تلقائياً.`,
      telegram_admins_log_group: "ID مجموعة مراقبة إشعارات التيليجرام",
      network_accounts_bot: "البوت الخاص باستعلامات الزبائن",
      netowrk_accounts_bot_note:
        "يمكنك هذا الخيار من اضافة بوت خاص بك تقوم انت بإنشاءه باسم الشبكة لديك ليستخدمه الزبائن في الاستعلام عن حساباتهم وتفاصيلها واستلام الإشعارات",
      network_accounts_bot_note2:
        "للحصول على البوت توجه على التلغرام على البوت {'@'}botfather وقم بإنشاء البوت الخاص بك ثم قم بلصق التوكن الخاص بالبوت هنا token.",

      telegram_settings_updated_successfully: "تم تحديث اعدادات التلغرام بنجاح",
      telegram_bot_already_used: "بوت التلغرام هذا مستخدم مسبقا",
      account_notifications_enabled:
        "وصول اشعارات للمستخدمين المسجلين عن طريق هذا البوت",
    },
    config: {
      expiring_enabled: "تفعيل إشعارات اقتراب انتهاء الحساب",
      expired_enabled: "تفعيل إشعارات انتهاء الحساب",
      renew_enabled: "تفعيل إشعارات تجديد الحساب",
      create_enabled: "تفعيل إشعارات إنشاء الحساب",
      expiring_body: "رسالة اقتراب انتهاء الحساب",
      expired_body: "رسالة إنتهاء الحساب",
      renew_body: "رسالة تجديد الحساب",
      support_number: "رقم التواصل او الاستفسار (يظهر داخل الرسالة)",
      support_number_invalid: "يجب ان يبدأ الرقم برمز +",
      sham_renew_enabled: "تفعيل رسالة تجديد الحساب بواسطة شام كاش",
      sham_code_enabled:
        "تفعيل ظهور رمز شام كاش عند انتهاء الاشتراك (رمز الدفع)",
      available_variables: "المتغيرات المتاحة",
      variables_note:
        "يمكنك استخدام هذه المتغيرات في نص الإشعار وسيتم استبدالها بالقيم المناسبة عند الإرسال",
      username: "اسم المستخدم",
      fullname: "الاسم الكامل",
      profile_name: "اسم البروفايل",
      profile_price: "سعر البروفايل",
      sham_cash_code: "رمز شام كاش",
      total_debts: "إجمالي الديون",
      expires_at: "تاريخ الانتهاء",
      network_name: "اسم الشبكة",
      do_not_put_links_inside_the_message:
        "لا تقم بوضع روابط داخل الرسالة لتجنب حظر الرقم",
      custom_expiration_message: "رسالة انتهاء مخصصة",
      custom_renew_message: "رسالة تجديد مخصصة",
      custom_expiring_soon_message: "رسالة اقتراب انتهاء مخصصة",
      custom_sham_renew_message: "رسالة تجديد عن طريق شام كاش مخصصة",
      debt: "المتبقي",
      paid_amount: "المدفوع",
      discount: "الخصم",
      invoice_number: "رمز الفاتورة",
      expiration_message: "رسالة الانتهاء",
      renew_message: "رسالة التجديد",
      expiring_soon_message: "رسالة اقتراب الانتهاء",
      sham_renew_message: "رسالة تجديد شام كاش",
      sms_username: "اسم مستخدم SMS",
      sms_password: "كلمة مرور SMS",
      sms_sender: "مرسل SMS",
      disabled: "معطل",
      service: "الخدمة",
      sms_network_identifier: "مفتاح الاشتراك",
    },
    raselsms: {
      ssradius_sms_stats: "إحصائيات SSRadius SMS",
      activated: "مفعلة",
      charged_messages: "الرسائل المشحونة",
      remaining_messages: "الرسائل المتبقية",
      total_success: "إجمالي الرسائل الناجحة",
      total_failed: "إجمالي الرسائل الفاشلة",
      current_month_success: "الرسائل الناجحة هذا الشهر",
      current_month_failed: "الرسائل الفاشلة هذا الشهر",
    },
    automatic_notifications: "الإشعارات التلقائية",
    automatic_notifications_app: "إشعارات تطبيق الجوال",
    this_will_archive_notification: "سيؤدي هذا إلى ارشفة الاشعار",
    notification_archived: "تمت ارشفة الاشعار",
    notifications_archived: "تمت ارشفة الاشعارات المحددة",
    this_will_archive_all_selected_notifications:
      "سيؤدي هذا إلى ارشفة الاشعارات المحددة",
    archived: "أرشفة",
    this_will_delete_whatsapp_key_and_disconnect_it:
      "سيؤدي هذا إلى حذف مفتاح واتساب وفصل الاتصال",
    whatsapp_key_deleted: "تم حذف مفتاح واتساب وفصل الاتصال بنجاح",
    sms_notifications: "إشعارات SMS",
  },
  admins_log: {
    id: "الرقم التسلسلي",
    username: "اسم المستخدم",
    operation: "العملية",
    details: "التفاصيل",
    date: "التاريخ",
  },
  transactions: {
    id: "الرقم التسلسلي",
    username: "المستلم",
    account_username: "اسم الاشتراك",
    type: "النوع",
    amount: "المبلغ",
    subject: "الموضوع",
    notes: "ملاحظات",
    withdraw: "سحب",
    deposit: "دفع",
    paid_amount: "المبلغ المدفوع",
    required_amount: "المبلغ المطلوب",
    remaining: "باقي عليه دفع",
    pay: "دفع",
    discount: "الخصم",
  },
  bills: {
    slug: "الرمز",
    price: "السعر",
    paid: "المدفوع",
    from: "من",
    remaining: "المتبقي",
    to: "إلى",
    notes: "ملاحظات",
    pay_bill: "تسديد الفاتورة",
    pay: "تسديد",
    pay_confirm: "هل انت متأكد من تسديد الفاتورة بالمبلغ المحدد؟",
    bill_paid: "تم تسديد الفاتورة بنجاح",
    notification_sent: "تم إرسال الإشعار بنجاح",
    total: {
      total_grand: "المجموع الكلي",
      total_paid: "مجموع المدفوعات",
      total_debt: "مجموع الديون",
      current_grand: "مجموع الصفحة الحالية",
      current_paid: "مدفوعات الصفحة الحالية",
      current_debt: "ديون الصفحة الحالية",
    },
    invoice: {
      bill_to: "فاتورة للسيد",
      issued_date: "تاريخ الإصدار",
      account_id: "رقم الحساب",
      bill_id: "رقم الفاتورة",
      profile: "اسم الاشتراك",
      description: "تفاصيل",
      amount: "المبلغ",
      remaining: "المتبقي",
      issued_by: "تم الإصدار بواسطة",
      issued_date: "تاريخ الإصدار",
      updated_at: "تاريخ التحديث",
      actions: "العمليات",
    },
    invoice_number: "رقم الفاتورة",
    admin: "المدير",
    invoice_at: "تاريخ الفاتورة",
    created_at: "تاريخ الدفع",
    actions: "العمليات",
    bills_columns: "أعمدة الفواتير",
    code: "الرمز",
    receiver: "المستلم",
    account: "الحساب",
    profile: "البروفايل",
    paid_amount: "المبلغ المدفوع",
    from_date: "من",
    to_date: "إلى",
    payment_date: "تاريخ الدفع",
    reseller: "الوكيل",
    type: "النوع",
    amount: "المبلغ",
    notify: "تذكير",
    this_will_delete_bill_and_return_expiration_to_previous_value:
      "سيؤدي هذا إلى حذف الفاتورة وإعادة تاريخ الانتهاء إلى القيمة السابقة",
    yes_delete: "نعم، أحذف",
    bill_has_been_deleted: "تم حذف الفاتورة بنجاح",
    filter: "تصفية",
    clear: "مسح",
    search_from_date: "بحث من تاريخ",
    search_to_date: "إلى تاريخ",
    name: "الاسم",
  },
  ip_addresses: {
    add_public_ip_address: "إضافة عنوان IP عام",
    add_public_ip_address: "إضافة عنوان IP عام",
    ip_address: "عنوان IP",
    ports_range_length: "طول نطاق البورتات",
    ranges_count: "عدد النطاقات",
    used_ranges: "النطاقات المستخدمة",
    add_ip_pool: "إضافة IP Pool",
    pool_name: "اسم IP Pool",
    from: "من",
    to: "إلى",
    addresses_count: "عدد العناوين",
    delete_public_ip_permanently: "حذف عنوان IP العام بشكل دائم",
    this_will_delete_public_ip_permanently:
      "سيؤدي هذا إلى حذف عنوان IP العام بشكل دائم",
    yes_am_sure_delete_it: "نعم، أنا متأكد من حذفه",
    public_ip_has_been_deleted_successfully: "تم حذف عنوان IP العام بنجاح",
  },
  license: {
    license: "الترخيص",
    realm: "الريلم",
    online: "الجلسات المتصلة",
    remaining: "الجلسات المتبقية",
    serial_number: "الرقم السري",
    id: "معرف الجهاز",
    ip: "IP",
    device: "الجهاز",
    subscription: "الاشتراك",
    full_name: "الاسم الكامل",
    name: "الاسم",
    network: "الشبكة",
    expires_at: "تاريخ الانتهاء",
    package: "الخطة",
    package_name: "الاسم",
    package_details: "التفاصيل",
    package_months: "(اشهر) المدة",
    package_online_count: "الجلسات المتصلة المسموحة",
    package_nases_count: "عدد الشبكات المسموح",
    package_admins_count: "عدد المدراء المسموح",
    package_resellers_count: "عدد الوكلاء المسموح",
    update: "تحديث الرخصة",
    update_error: "فشل تحديث الرخصة",
    update_success: "تم تحديث الرخصة بنجاح",
    phone: "رقم الهاتف",
    email: "البريد الالكتروني",
  },
  restore: {
    choose_file: "إختيار ملف",
    import: "إستيراد",
    import_dma: "DMA إستيراد ملف من",
    import_local: "إستيراد نسخة احتياطية SSR",
    file_ready: "الملف جاهز",
    restore_radacct: "(radacct) إستعادة الجلسات المستهلكة",
    restore_radacct_false: "(radacct) عدم إستعادة الجلسات المستهلكة",
    warning_radacct:
      "تحذير ! قد تستغرق العملية وقتاً يصل إلى 30 دقيقة حسب حجم فاعدة البيانات",
    clean_restore: "مسح البيانات السابقة",
    clean_restore_false: "الاحتفاظ بالبيانات السابقة",
    import_nas: "استعادة البيانات المستخرجة من شبكة SSR",
    warning_nas:
      "تحذير! استعادة بيانات الشبكة تسبب مسح كامل قاعدة البيانات السابقة",
  },
  backup: {
    file_name: "الاسم",
    action: "العملية",
    download: "تحميل",
    delete: "حذف",
    now: "حفظ نسخة الان",
  },
  iptv: {
    logo: "شعار القناة",
    name: "اسم القناة",
    url: "رابط بث القناة",
    add: "اضافة قناة",
    add_channel: "إضافة قناة",
    enabled: "تفعيل ظهور القنوات لمستخدمين التطبيق",
    delete_channel: "حذف القناة",
    this_will_delete_selected_channel: "سيؤدي هذا إلى حذف القناة المحددة",
    yes_delete_it: "نعم احذف",
    channel_deleted_successfully: "تم حذف القناة بنجاح",
  },
  updates: {
    name: "اسم التحديث",
    change_log: "التغييرات",
    download_install: "تحميل وتثبيت",
    downloading_message: "جار التحميل...",
    downloading_fail: "فشل التحميل",
    installing_message: "جار التثبيت",
    installing_fail: "فشل التثبيت",
  },
  reports: {
    yearly: "سنوي",
    monthly: "شهري",
    daily: "يومي",
    duration: "مدة محددة",
    year: "سنة",
    month: "شهر",
    day: "يوم",
    hour: "ساعة",
    from: "من",
    to: "إلى",
    generate: "توليد",
    finance_report: "تقرير مالي",
    finance: "تقرير مالي",
    sells_report: "تقرير مبيعات",
    sells: "تقرير مبيعات",
    amount: "المبلغ",
    accounts: "الحسابات",
    cards: "البطاقات",
    profile: "البروفايل",
    accounts_count: "عدد الحسابات",
    batch: "المجموعة",
    cards_count: "عدد البطاقات",
    total: "الاجمالي",
    frequency: "النمط",
    reseller: "تقرير مبيعات الوكيل",
    bills_count: "عدد الفواتير",
  },
  bandwidth: {
    title: "ضبط السرعة",
    total_use: "كل البروفايلات",
    total_peak: "الاستخدام الاقصى لجميع الحسابات المتصلة",
    total_average: "الاستخدام المتوسط لجميع الحسابات المتصلة",
    reset: "اعادة ضبط افتراضي",
    update: "حفظ وتحديث الكل",
    online_accounts: "حساب متصل",
    online_peak_band: "الاستخدام الاقصى للحسابات المتصلة",
  },
  ips: {
    public: {
      ip_address: "عنوان IP",
      division_ports_count: "طول المجال",
      used_count: "المجالات المستخدمة",
      count: "عدد المجالات",
      add: "إضافة عنوان ايبي",
      public_address: "العنوان العام",
    },
    pool: {
      name: "اسم المجموعة",
      start_ip: "من",
      end_ip: "إلى",
      ips_count: "عدد العناوين",
      used_ips: "العناوين المستخدمة",
      add: "إضافة مجموعة عناوين",
      ip_address: "عنوان IP",
      delete_ip_pool_permanently: "حذف مجموعة عناوين IP بشكل دائم",
      this_will_delete_ip_pool_permanently:
        "سيؤدي هذا إلى حذف مجموعة عناوين IP بشكل دائم",
      yes_am_sure_delete_it: "نعم، أنا متأكد من حذفها",
      ip_pool_has_been_deleted_successfully: "تم حذف مجموعة عناوين IP بنجاح",
    },
  },
  maps: {
    add_marker: "إضافة علامة",
    map_filters: "تصفية الخريطة",
    accounts: "الحسابات",
    markers: "العلامات",
    all: "عرض الكل",
    online: "متصل",
    offline: "غير متصل",
    expired: "منتهي الصلاحية",
    none: "إخفاء الكل",
    label: "التسمية",
    color: "اللون",
    click_on_map_to_add_marker: "انقر على الخريطة لإضافة علامة",
    location_updated_successfully: "تم تحديث الموقع بنجاح",
    marker_updated_successfully: "تم تحديث العلامة بنجاح",
    marker_deleted_successfully: "تم حذف العلامة بنجاح",
    marker_added_successfully: "تم إضافة العلامة بنجاح",
    error_storing_marker: "حدث خطأ اثناء إضافة العلامة",
    error_deleting_marker: "حدث خطأ اثناء حذف العلامة",
    error_updating_marker: "حدث خطأ اثناء تحديث العلامة",
    network_devices: "تجهيزات الشبكة",
  },
  sales: {
    id: "الرقم التسلسلي",
    name: "اسم المنتج",
    type: "النوع",
    description: "الوصف",
    notes: "الملاحظات",
    price: "السعر",
    paid: "المدفوع",
    account: "الحساب",
    user: "المستلم",
    add_sales: "إضافة عملية بيع",
    purchases: "المشتريات",
    new_sale_added: "تم إضافة عملية بيع جديدة",
    this_will_delete_sale_record: "سيؤدي هذا إلى حذف سجل عملية البيع",
    yes_delete: "نعم, احذف",
    deleteted: "تم الحذف",
    sale_has_been_deleted: "تم حذف عملية البيع",
    pay_sale: "تسديد عملية البيع",
    pay_sale_confirm: "هل انت متأكد من تسديد عملية البيع بالمبلغ المحدد؟",
    sale_paid: "تم تسديد عملية البيع",
    pay: "دفع",
  },
  wizard: {
    new_password: "كلمة المرور الجديدة",
    new_password_confirmation: "تأكيد كلمة المرور الجديدة",
    weak_password: "كلمة المرور ضعيفة",
    passwords_not_match: "كلمتا المرور غير متطابقتان",
    setup_wizard: "معالج الإعداد",
    color_theme: "نظام الالوان",
    light: "فاتح",
    dark: "داكن",
    welcome_to_super_speed_radius: " اهلا بكم في خدمة Super Speed Radius",
    this_guide_will_help_you_choose_default_options_for_your_subscription:
      "سوف يساعدكم هذا الإعداد على اختيار الاعدادات الافتراضية للنظام لضمان استخدام خدمات SSRadius بشكل صحيح ومساعدتنا على تقديم افضل خدمة لكم.",
    it_will_not_take_more_than_minutes: "لن يستغرق هذا الإعداد سوى بضع دقائق.",
    please_change_network_name: "قم بتغيير اسم الشبكة من فضلك",
    setup_wizard_completed: "تم انجاز الضبط بنجاح",
    welcome_to_super_speed_radius: "اهلا بكم في Super Speed Radius",
  },
  tunnels: {
    nas: "الشبكة",
    port_to_forward: "البورت المراد تحويله",
    custom_input: "ادخال يدوي",
    generate_tunnel: "توليد رابط التحويل",
    remove_tunnel: "حذف الرابط",
    tunnel_generate_failed: "فشل توليد رابط التحويل",
    remote_tunnel: "رابط التحويل البعيد",
    tunnel_removed_successfully: "تم حذف رابط التحويل بنجاح",
    tunnel_remove_failed: "فشل حذف رابط التحويل",
    tunnel_generated_successfully: "تم توليد رابط التحويل بنجاح",
    go_to_url: "الذهاب إلى الرابط",
  },
  network_devices: {
    name: "اسم الجهاز",
    ip: "ايبي الجهاز",
    username: "اسم المستخدم",
    username_optional: "اسم المستخدم (اختياري)",
    password: "كلمة المرور",
    password_optional: "كلمة المرور (اختياري)",
    status: "البينغ",
    tunnel_url: "رابط الوصول عن بعد",
    this_will_delete_network_device_permanently:
      "سيؤدي هذا إلى حذف القطعة بشكل كامل",
    network_device_has_been_deleted_successfully: "تم حذف القطعة بنجاح",
    add_network_device: "إضافة جهاز على الشبكة",
    network_device_added_successfully: "تمت اضافة الجهاز بنجاح",
    network_device_addition_failed: "فشلت إضافة جهاز!",
    nas_name: "الشبكة",
    type: "نوع الجهاز",
    types: {
      other: "غير محدد",
      switch: "سويتش",
      router: "راوتر",
      server: "سيرفر",
      dish: "صحن",
      ap: "جهاز ارسال",
    },
    set_location_on_map: "تحديد الموقع على الخريطة",
    generate: "توليد",
  },
  vpns: {
    pptp_server: "خدمة PPTP",
    l2tp_ipsec_server: "خدمة L2TP/IPSec",
    add_vpn_connection: "إضافة اتصال VPN",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    ip: "عنوان IP",
    service: "الخدمة",
    vpn_connection: "اتصال VPN",
    settings: "إعدادات",
    running: "يعمل",
    stopped: "متوقف",
    start: "تشغيل",
    stop: "إيقاف",
    restart: "إعادة تشغيل",
    pptp_service_settings: "إعدادات خدمة PPTP",
    l2tp_service_settings: "إعدادات خدمة L2TP/IPSec",
    server_ip: "عنوان IP للخادم",
    ip_range: "نطاق عناوين IP",
    port: "البورت",
    pptp_settings_updated_successfully: "تم تحديث إعدادات PPTP بنجاح",
    pptp_settings_update_failed: "فشل تحديث إعدادات PPTP",
    l2tp_settings_updated_successfully: "تم تحديث إعدادات L2TP/IPSec بنجاح",
    l2tp_settings_update_failed: "فشل تحديث إعدادات L2TP/IPSec",
    service_stopped_successfully: "تم إيقاف الخدمة بنجاح",
    service_stop_failed: "فشل إيقاف الخدمة",
    service_started_successfully: "تم تشغيل الخدمة بنجاح",
    service_start_failed: "فشل تشغيل الخدمة",
    service_restarted_successfully: "تم إعادة تشغيل الخدمة بنجاح",
    service_restart_failed: "فشل إعادة تشغيل الخدمة",
    delete_vpn_connection_confirm: "هل أنت متأكد من حذف اتصال VPN هذا؟",
    vpn_connection_deleted_successfully: "تم حذف اتصال VPN بنجاح",
    vpn_connection_delete_failed: "فشل حذف اتصال VPN",
    restart_is_required_to_update_settings:
      "يجب اعادة تشغيل الخدمة لتطبيق الاعدادت",
    connect_ip: "الايبي المستخدم للاتصال",
    mikrotik_link_scripts: "اكواد الربط مع ميكروتيك",
    link: "الربط",
  },
  mikrotik_log: {
    nasname: "الشبكة",
    topic: "النوع",
    details: "تفاصيل",
    date: "التوقيت",
  },
  documents: {
    document_type: "نوع المستند",
    extension: "الامتداد",
    size: "الحجم",
    created_at: "تاريخ الانشاء",
    uploader: "المدير",
    actions: "العمليات",
    download: "تحميل",
  },
  vouchers: {
    code: "الرمز",
    batch_name: "اسم المجموعة",
    user: "المالك",
    status: "الحالة",
    amount: "الرصيد",
    valid_before: "تاريخ انتهاء الصلاحية",
    redeemed: "تم الاستخدام",
    canceled: "ملغى",
    notes: "ملاحظات",
    created_at: "تاريخ الانشاء",
    cancel: "إلغاء",
    used_by: "مستخدمة من قبل",
    statuses: {
      created: "تم الانشاء",
      issued: "تم التوزيع",
      pending: "جار المعالجة",
      redeemed: "تم الاستخدام",
      expired: "منتهية",
      canceled: "معطلة",
      0: "تم الانشاء",
      1: "تم التوزيع",
      2: "جار المعالجة",
      3: "تم الاستخدام",
      4: "منتهية",
      5: "معطلة",
    },
    cancel_voucher: "تعطيل الكرت",
    this_will_cancel_selected_voucher: "سيؤدي هذا إلى تعطيل الكرت المحدد",
    yes_cancel: "نعم تعطيل",
    voucher_has_been_canceled: "تم تعطيل الكرت بنجاح",
    accounts_application_credits_charge: "بطاقة شحن رصيد محفظة التطبيق",
    printing_batch: "طباعة المجموعة",
    count: "عدد الكروت",
  },
  vouchers_batches: {
    vouchers_batches_columns: "اعمدة مجموعات الكروت",
    name: "الاسم",
    valid_before: "تاريخ انتهاء الصلاحية",
    user: "المالك",
    voucher_value: "قيمة الكرت",
    vouchers_count: "عدد الكروت",
    created_at: "تاريخ الانشاء",
    generate_vouchers: "توليد كروت شحن",
    redeemed_vouchers_count: "عدد الكروت المستخدمة",
    expired_vouchers_count: "عدد الكروت المنتهية",
    canceled_vouchers_count: "عدد الكروت المعطلة",
    currency: "العملة",
    delete_batch_permanently: "حذف المجموعة بشكل نهائي",
    this_will_delete_batch_and_all_its_cards_permanently_and_you_cannot_get_the_money_back:
      "هل انت متأكد من حذف المجموعة وجميع الكروت التي تتبع لها، لن تتمكن من استعادة الرصيد المستخدم",
    batch_has_been_permanently_delete: "تم حذف المجموعة بشكل نهائي",
    this_will_cancel_batch_and_all_its_cards_permanently:
      "سيؤدي هذا إلى تعطيل جميع الكروت التي تتبع لهذه المجموعة",
    batch_has_been_canceled: "تم تعطيل المجموعة",
    cancel_batch: "إلغاء المجموعة",
    delete_batch: "حذف المجموعة",
    batch_name: "اسم المجموعة",
    one_voucher_price: "سعر الكرت",
    quantity: "العدد",
    total_price: "السعر الاجمالي",
    total_payments: "التحصيل",
    used_vouchers: "الكروت المستخدمة",
    used_vouchers_percentage: "نسبة الكروت المستخدمة",
    notes: "ملاحظات",
    issued_date: "تاريخ الاصدار",
    updated_at: "تاريخ التحديث",
  },
  actions: {
    view: "عرض",
    edit: "تعديل",
    renew: "تجديد أو تغيير الإشتراك",
    clear: "مسح الجلسات",
    disconnect: "قطع الإتصال",
    enable: "تفعيل",
    disable: "تعطيل",
    delete: "حذف",
    view_profile: "عرض البروفايل",
    print: "طباعة",
    archive: "أرشفة",
    export_csv: " CSV تصدير",
    notify: "إشعار للتطبيق",
    view_sessions: "عرض الجلسات",
    edit_popup: "تعديل في نافذة جديدة",
    view_bills: "عرض الفواتير",
    renew_48: "مهلة 2 يوم",
    renew_72: "تفعيل ومهلة 3 يوم",
    renew_48_free: "إضافة 2 يوم مجاني",
    edit_money: "تعديل الرصيد",
    export_nas: "استخراج بيانات الشبكة",
    temp_speed: "تعديل مؤقت للسرعة",
    edit_expiration: "تعديل تاريخ الانتهاء",
    edit_profile: "تعديل بروفايل",
    copy: "نسخ",
  },
  control: {
    rows_10: "10 أسطر",
    rows_50: "50 أسطر",
    rows_100: "100 أسطر",
    rows_500: "500 أسطر",
    rows_all: "جميع الاسطر",
    yes: "نعم",
    no: "لا",
    back: "رجوع",
    of: "من",
    columns: "الأعمدة المرئية",
    filter: "بحث",
    enabled: "مفعل",
    any: "الكل",
    hotspot: "Hotspot",
    ppp: "PPP",
    subscribtion: "إشتراك",
    prepaid: "بطاقات",
    online: "متصل",
    offline: "غير متصل",
    all: "الكل",
    active: "مفعل",
    expired: "منتهي الصلاحية",
    seconds: "ثواني",
    minutes: "دقائق",
    hours: "ساعات",
    days: "أيام",
    months: "أشهر",
    years: "سنوات",
    unlimited: "غير محدود",
    details: "التفاصيل",
    created_at: "تاريخ الانشاء",
    updated_at: "اخر تعديل",
    allowed_quota: "الاستهلاك المسموح",
    remaining_quota: "الاستهلاك المتبقي",
    delete: "حذف",
    cancel: "إلغاء",
    total: "العدد الكلي:",
    from: "من",
    to: "إلى",
    disabled: "معطل",
    auto: "تلقائي",
    device: "جهاز",
    cost: (ctx) => `سوف تكلفك العملية: (${ctx.named("cost")})`,
    money_left: (ctx) =>
      `الرصيد المتبقي (${ctx.named("original")} => ${ctx.named("left")})`,
    profile_cost: (ctx) => `سعر البروفايل: ${ctx.named("price")}`,
    benefit_cost: (ctx) => `الربح: ${ctx.named("price")}`,
    pagination: (ctx) =>
      `عرض من ${ctx.named("from")} إلى ${ctx.named("to")} من اصل ${ctx.named(
        "total",
      )} سطر`,
    expiring: "على وشك الانتهاء",
    expiration_profile: "بروفايل انتهاء الخدمة",
    hours_24: "24 ساعة",
    months_1: "1 شهر",
    months_6: "6 أشهر",
    years_1: "1 سنة",
    fetch_failed: "تعذر",
    active_sessions: "عدد الاجهزة المتصلة",
    commit: "تطبيق الاعدادات",
    commited: "تم التطبيق",
    warning: "تحذير",
    save_filters: "حفظ الفلاتر",
    sum: "المجموع",
    clear: "مسح",
    save: "حفظ",
    new_updates: "تحديث جديد",
    click_to_update: "انقر للتحديث",
    default: "الافتراضي",
    ok: "تم",
    benefit: "الربح",
    export: "تصدير",
    auto_update: "تحديث تلقائي",
    columns_visible: "الأعمدة المرئية",
    show: "عرض",
    search: "بحث",
    light: "فاتح",
    dark: "داكن",
    system: "نظام",
    previous: "السابق",
    next: "التالي",
    add: "إضافة",
    manual: "يدوي",
    submit: "إرسال",
    are_you_sure: "هل انت متأكد؟",
    some_thing_went_wrong_please_try_again:
      "حدث خطأ ما. الرجاء المحاولة مرة اخرى",
    success: "تم بنجاح",
    error: "خطأ",
    apply: "تطبيق",
    disconnect: "قطع الاتصال",
    the_operation_was_cancelled: "تم إلغاء العملية",
    changes_saved_successfully: "تم حفظ التغييرات بنجاح",
    error_while_saving_changes: "حدث خطأ أثناء حفظ التغييرات",
    update: "تحديث",
    actions: "العمليات",
    none: "لا يوجد",
    print: "طباعة",
    csv: "تصدير CSV",
    pdf: "تصدير PDF",
    show_more_details: "عرض كامل التفاصيل",
    save_and_close: "حفظ وإغلاق",
    no_one: "لا أحد",
    copied_to_clipboard: "تم النسخ إلى الحافظة",
    click_to_copy: "انقر للنسخ",
    skip: "تخطي",
    view_tour: "جولة في الميزات",
    skip_this_time: "تخطي هذه المرة",
    not_expired: "ساري الصلاحية",
    visible: "مرئي",
    hidden: "مخفي",
    restore_options: "خيارات الاستعادة",
    fail: "فشل",
    an_error_occurred_while_uploading: "حدث خطأ أثناء الرفع",
    error_while_updating: "حدث خطأ أثناء التحديث",
    update_failed: "فشل التحديث",
    installing_fail: "فشل التثبيت",
    installing_update: "جار تثبيت التحديث",
    please_wait_while_update_is_being_installed:
      "يرجى الانتظار أثناء تثبيت التحديث",
    downloading_fail: "فشل التحميل",
    please_wait_while_update_is_being_downloaded:
      "يرجى الانتظار أثناء تحميل التحديث",
    downloading_update: "جار تحميل التحديث",
    failed_to_update_license: "فشل تحديث الترخيص",
    license_updated_successfully: "تم تحديث الترخيص بنجاح",
    import_successful: "تم الاستيراد بنجاح",
    import_failed: "فشل الاستيراد",
    error_while_importing: "حدث خطأ أثناء الاستيراد",
    error_while_creating_backup: "حدث خطأ أثناء إنشاء النسخة الاحتياطية",
    backup_failed: "فشل النسخ الاحتياطي",
    backup_created_successfully: "تم إنشاء النسخة الاحتياطية بنجاح",
    file_has_been_deleted: "تم حذف الملف بنجاح",
    you_are_about_to_delete: "أنت على وشك حذف",
  },
  operations: {
    account_create: "حسابات: انشاء",
    account_create_cost: "حسابات: تكلفة الانشاء",
    account_expiration: "حسابات: تعديل تاريخ انتهاء",
    account_password: "حسابات: تعديل كلمة مرور",
    account_sessions: "حسابات: مسح الجلسات",
    account_username: "حسابات: تعديل اسم المستخدم",
    account_allowed_sessions: "حسابات: تعديل الاجهزة المسموحة",
    account_update: "حسابات: تعديل",
    account_delete: "حسابات: حذف",
    account_disconnect: "حسابات: قطع اتصال",
    account_enable: "حسابات: تفعيل",
    account_disable: "حسابات: تعطيل",
    account_renew: "حسابات: تجديد اشتراك",
    account_renew_cost: "حسابات: تكلفة التجديد",
    account_next_profile: "حسابات: تحديد البروفايل التالي",
    account_renew48: "حسابات: مهلة 2 يوم",
    account_renew48_free: "حسابات: تمديد 2 يوم مجاني",
    account_renew72: "حسابات: تفعيل ومهلة 3 ايام",
    account_login_mobile: "حسابات تطبيق: تسجيل دخول",
    account_renew_mobile: "حسابات تطبيق: تجديد الاشتراك",
    account_renew48_mobile: "حسابات تطبيق: مهلة 2 يوم",
    account_disconnect_mobile: "حسابات تطبيق: قطع الاتصال",
    account_update_mobile: "حسابات تطبيق: تحديث البيانات",
    account_double_speed_mobile: "حسابات تطبيق: مضاعفة السرعة",
    account_open_speed_mobile: "حسابات تطبيق: فتح السرعة",
    bill_pay_mobile: "حسابات تطبيق: دفع فاتورة",
    admins_add: "مدراء: انشاء",
    admins_update: "مدراء: تعديل",
    admins_delete: "مدراء: حذف",
    admins_password: "مدراء: تعديل كلمة المرور",
    resellers_add: "وكلاء: انشاء",
    resellers_money: "وكلاء: تحديث الرصيد",
    card_design_save: "بطاقات: حفظ التصميم",
    cards_generate: "بطاقات: توليد بطاقات",
    cards_generate_cost: "بطاقات: تكلفة توليد البطاقات",
    card_password: "بطاقات: تعديل كلمة مرور",
    card_expiration: "بطاقات: تعديل تاريخ انتهاء",
    card_allowed_sessions: "بطاقات: تعديل الاجهزة المسموحة",
    card_edit: "بطاقات: تعديل",
    card_delete: "بطاقات: حذف بطاقة",
    cards_delete: "بطاقات: حذف مجموعة",
    card_clear_sessions: "بطاقات: مسح جلسات",
    card_disconnect: "بطاقات: قطع اتصال",
    card_enable: "بطاقات: تفعيل",
    card_disable: "بطاقات: تعطيل",
    session_disconnect: "جلسات: قطع اتصال",
    mikrotik_services_update: "خدمات: تعديل خدمات ميكروتيك",
    nas_create: "شبكات: انشاء",
    nas_update: "شبكات: تحديث",
    nas_delete: "شبكات: حذف",
    nas_api_commit: "شبكات: تطبيق الاعدادات",
    notify_account: "اشعارات: إرسال الى حساب",
    notify_card: "اشعارات: ارسال الى بطاقة",
    notify_profile: "اشعارات: ارسال الى حسابات بروفايل",
    notify_nas: "اشعارات: ارسال الى حسابات شبكة",
    notify_ssr: "اشعارات: ارسال الى حسابات مدير",
    notifications_archive: "اشعارات: ارشفة",
    profiles_create: "بروفايلات: انشاء",
    profile_update: "بروفايلات: تعديل",
    profile_delete: "بروفايلات: حذف",
    profile_disable: "بروفايلات: تعطيل",
    profile_enabled: "بروفايلات: تفعيل",
    profiles_delete: "بروفايلات: حذف",
    support_ticket_delete: "طلبات الصيانة: حذف",
    support_ticket_update: "طلبات الصيانة: تعديل",
    support_ticket_create: "طلبات الصيانة: انشاء",
    settings_update: "اعدادت النظام: تعديل",
    database_backup: "اعدادت النظام: نسخ احتياطي",
    database_backup_auto: "اعدادات النظام: نسخ احتياطي تلقائي",
    admin_login: "تسجيل دخول: مدير",
    reseller_login: "تسجيل دخول: وكيل",
    reseller_benefit: "وكلاء: ارباح",
    reseller_money_withdraw: "وكلاء: سحب رصيد",
    reseller_money_deposit: "وكلاء: إضافة رصيد",
    reseller_bill_delete: "وكلاء: حذف فاتورة",
    reseller_benefit_delete: "وكلاء: سحب ربح",
    reseller_bill_return: "وكلاء: إرجاع فاتورة",
    bill_pay: "فواتير: دفع فاتورة",
    bill_delete: "فواتير: حذف فاتورة",
  },
  currencies: {
    usd: "دولار امريكي $",
    tr: "ليرة تركية ₺",
    syp: "ليرة سورية SYP",
    iqd: "دينار عراقي IQD",
    jd: "دينار اردني JD",
    lbp: "ليرة لبنانية LBP",
    egp: "جنيه مصري EGP",
    sar: "ريال سعودي SAR",
    sud: "جنيه سوداني SDG",
    mad: "درهم مغربي MAD",
  },
  errors: {
    update_available: "تحديث متاح",
    update_available_message:
      "يوجد تحديث جديد متاح، هل ترغب في تحميله وتثبيته؟",
    required: "هذا الحقل مطلوب",
    accounts: {
      username_empty: "لا يمكن ان يكون اسم المستخدم فارغاً",
      username_2: "يجب ان يحتوي اسم المستخدم على حرفين أو أكثر",
      username_symbol: "لايمكن ان يحتوي اسم المستخدم على رموز",
      username_taken: "اسم المستخدم محجوز مسبقاً",
      invalid_ip: "ايبي خاطئ",
      password_empty: "لا يمكن ان تكون كلمة المرور فارغة",
      password_2: "يجب ان يحتوي كلمة المرور على حرفين أو أكثر",
      select_profile: "يرجى تحديد البروفايل",
      sessions_warning:
        "تنبيه: يؤدي عدم حفظ الجلسات إلى فقدان كمية استهلاك الحزمة",
      serial_number_taken: "الرقم التسلسلي مستخدم مسبقا",
    },
    batches: {
      name_empty: "الرجاء ادخال اسم المجموعة",
      name_taken: "اسم المجموعة مستخدم مسبقاً",
      username_length_6: "يجب ان يحوي اسم المستخدم على 6 محارف أو اكثر",
      password_length_3: "يجب ان تحوي كلمة المرور على 3 محارف أو اكثر",
      chars: "عدد محارف اسم المستخدم غير كافي لتوليد هذا العدد من البطاقات",
      truncate_failed: "فشل الحذف",
      not_enough:
        "تعذر توليد الكمية المطلوبة باستخدام 3 محارف لاسم المستخدم، الرجاء حذف البطاقات القديمة وافراغ المساحة أو زيادة عدد المحارف",
      username_length_8:
        "يجب ان يحتوي اسم المستخدم على 8 محارف او اكثر عند الغاء كلمة المرور",
    },
    profiles: {
      name_empty: "يرجو ادخال الاسم",
      name_taken: "الاسم مستخدم مسبقاً",
      nases_1: "الرجاء اختيار شبكة 1 على الاقل",
      speed_0: "يرجى تحديد السرعة",
      app_allowed_zero_profile:
        "انتبه! سعر هذا البروفايل يساوي 0 عند تفعيله للاستخدام من التطبيق سوف يتمكن المشترك من تفعيله مجاناً",
    },
    nases: {
      ip: "الايبي غير صالح",
      name: "لايمكن ترك الاسم فارغا",
      api_port: "البورت يجب ان يكون رقم",
    },
    admins: {
      first_name: "الاسم إجباري",
      last_name: "الكنية إجبارية",
      username_3: "يجب ان يحتوي اسم المستخدم على 3 أحرف على الأقل",
      username_taken: "اسم المستخدم مستعمل مسبقاً",
      password_3: "يجب ان تحتوي كلمة المرور على 3 أحرف على الأقل",
    },
    restore: {
      uploading: "فشل الرفع !!",
      parsing: "فشلت المعالجة !!",
      cleaning: "فشل المسح !!",
      server: "حدث خطأ في المخدم يرجى إعادة المحاولة",
    },
    notifications: {
      empty: "الإشعار لا يمكن ان يكون فارغ",
      wa: {
        not_found: "المفتاح غير صحيح",
        already_used: "المفتاح مستخدم مسبقاً",
        url: "لايمكن ان تحتوي الرسالة على روابط",
      },
    },
    support_tickets: {
      account_id: "قم باختيار الحساب",
      issue: "لايمكن ترك المشكلة فارغة",
    },
    license: {
      expiring: (ctx) =>
        `تحذير: ينتهي اشتراكك في خدمة SSR بعد ${ctx.named(
          "days",
        )} ايام، قم بتجديد الاشتراك كي لا تفقد التحكم`,
      expiring_sessions: (ctx) =>
        `تحذير: قمت باستهلاك ${ctx.named(
          "percent",
        )}% من الجلسات المتصلة المسموح بها، قم بزيادة الاشتراك كي لا يفقد المشتركين القدرة على تسجيل الدخول`,
      expired_title: "انتهاء الاشتراك",
      expired:
        "لقد انتهت المدة المحددة للاشتراك الخاص بك، قم بتجديد الاشتراك كي تستعيد الوصول",
      expired_sessions:
        "انتهاء الجلسات: لقد انتهت الجلسات المسوحة للاتصال لن تتمكن الحسابات من الاتصال حتى تقوم بزيادة الاشتراك",
      auth_offline:
        "فشل التحقق من الترخيص! تأكد من الاتصال بالانترنت، بعض الميزات لن تعمل حتى اتمام التحقق",
      privileges: "لاتمتلك الصلاحيات المطلوبة!",
      license_nases_exceeded: "لا يمكن تجاوز عدد الشبكات المسموح في الرخصة",
      license_admins_exceeded: "لا يمكن تجاوز عدد المدراء المسموح في الرخصة",
      license_resellers_exceeded: "لا يمكن تجاوز عدد الوكلاء المسموح في الرخصة",
    },
    iptv: {
      name_empty: "لايمكن ترك اسم القناة فارغاً",
      url_empty: "لا يمكن ترك رابط القناة فارغاً",
    },
    ips: {
      ip_required: "يجب تحديد العناوين",
      ips_error: "فشل تحديث العنوان",
      pool_error: "فشل تحديث المجموعة",
      range_reversed: "النهاية قبل البداية",
    },
    network_devices: {
      name_required: "لا يمكن ترك الاسم فارغاً",
      ip_required: "لا يمكن ترك العنوان فارغاً",
      invalid_ip: "الرجاء إدخال عنوان صحيح",
      nas_id: "الرجاء تحديد الشبكة",
    },
    vpns: {
      field_required: "هذا الحقل مطلوب",
      invalid_ip: "الرجاء إدخال عنوان IP صحيح",
      password_must_be_at_least_3_chars:
        "يجب ان تحتوي كلمة المرور على 3 احرف على الاقل",
      username_must_be_at_least_3_chars:
        "يجب ان يحتوي اسم المستخدم على 3 احرف على الاقل",
    },
    vouchers_batches: {
      name_empty: "لا يمكن ترك الاسم فارغا",
      cannot_be_less_than_1: "لايمكن تحديد القيمة اقل من 1",
      money_not_enough_to_complete_the_operation_required:
        "الرصيد غير كاف لاتمام العملية. المطلوب ",
    },
  },
  messages: {
    delete_confirm: "هل انت متأكد من الحذف ؟",
    accounts: {
      delete_all:
        "هل انت متأكد من حذف الحسابات المحددة ؟ لايمكنك التراجع عن هذه العملية",
      clear_all:
        "هل انت متأكد من حذف جلسات الحسابات المحددة ؟ لايمكنك التراجع عن هذه العملية",
      disable: "هل انت متأكد من تعطيل الحساب",
      disconnect: "هل انت متأكد من قطع اتصال الحساب ؟",
      clear: "هل انت متأكد من مسح اسهتلاك الحزمة لهذا الحساب ؟",
      enable: "هل انت متأكد من تفعيل الحساب",
      auto_mac:
        "اترك هذا الحقل فارغاً ليقوم النظام بتثبيت عنوان اول جهاز تلقائيا",
      not_expiring_soon: "ينتهي هذا الحساب بعد أكثر من 10 أيام",
      warning: "تنبه",
    },
    cards: {
      delete_all:
        "هل انت متأكد من حذف البطاقات المحددة ؟ لايمكنك التراجع عن هذه العملية",
      disable: "هل انت متأكد من تعطيل البطاقة المحددة ؟",
      disconnect: "هل انت متأكد من قطع اتصال البطاقة المحددة",
      clear: "هل انت متأكد من مسح اسهتلاك الباقة لهذه البطاقة ؟",
      enable: "هل انت متأكد من تفعيل البطاقة المحددة ؟",
      truncate: "هل انت متأكد من حذف جميع البطاقات المنتهية؟",
      delete: "هل انت متأكد من حذف البطاقة المحددة؟",
    },
    batches: {
      is_mac: "السماح لعنوان ماك الاول فقط باستخدام البطاقة",
    },
    profiles: {
      delete_all:
        "هل انت متأكد من حذف البروفايلات المحددة وجميع الحسابات والبطاقات المرتبطة بها ؟ لايمكنك التراجع عن هذه العملية",
      disable_all:
        "هل انت متأكد من تعطيل إضافة حسابات جديدة بواسطة هذا البروفايل ؟",
      open:
        "لن تعمل فتح السرعات ان قمت باستخدام خيار البروفايل التشاركي او السمات المخصصة",
    },
    admins: {
      delete_all:
        "هل انت متأكد من حذف المدراء المحددين ؟ لايمكنك التراجع عن هذه العملية",
    },
    restore: {
      uploading: "10% رفع البيانات",
      parsing: "40% معالجة البيانات",
      cleaning: "90% مسح التخزين المؤقت",
    },
    support_tickets: {
      delete_all:
        "هل انت متأكد من حذف الطلبات المحددة ؟ لايمكنك التراجع عن هذه العملية",
    },
    notifications: {
      archive: "هل انت متأكد من ارشفة وإخفاء الإشعار المحدد؟",
      archiveAll: "هل انت متأكد من ارشفة وإخفاء الإشعارات المحددة؟",
      wa_delete: "هل انت متأكد من حذف ترخيص واتساب؟",
    },
    nases: {
      delete_all:
        "هل انت متأكد من حذف الشبكات المحددة ؟ لايمكنك التراجع عن هذه العملية",
    },
    transactions: {
      no_debts: "تهانينا، الشبكة خالية من الديون",
    },
    bills: {
      delete:
        "هل انت متأكد من حذف الفاتورة المحددة ؟ لايمكنك التراجع عن هذه العملية.",
    },
    account_updated_successfully: "تم تحديث الحساب بنجاح",
    account_added_successfully: "تمت اضافة الحساب بنجاح",
    reseller_updated_successfully: "تم تحديث بيانات الوكلاء بنجاح",
    admin_updated_successfully: "تم تحديث بيانات المدير بنجاح",
    admin_created_successfully: "تمت اضافة المدير بنجاح",
    cards_batch_generated_successfully: "تم توليد مجموعة البطاقات بنجاح",
    card_updated_successfully: "تم تعديل البطاقة بنجاح",
    channel_added_successfully: "تمت اضافة القناة بنجاح",
    network_updated_successfully: "تم تحديث الشبكة بنجاح",
    network_added_successfully: "تمت اضافة الشبكة بنجاح",
    whatsapp_linked_successfully: "تم ربط واتس اب بنجاح",
    privileges_group_updated_successfully: "تم تحديث مجموعة الصلاحيات بنجاح",
    privileges_group_added_successfully: "تمت اضافة مجموعة صلاحيات بنجاح",
    ip_created_successfully: "تمت إضافة العنوان بنجاح",
    ip_updated_successfully: "تم تحديث العنوان بنجاح",
    ip_pool_updated_successfully: "تم تحديث مجموعة العناوين بنجاح",
    ip_pool_created_successfully: "تمت إضافة مجموعة العناوين بنجاح",
    notification_pushed_successfully: "تم إرسال الإشعار بنجاح",
    notification_settings_updated_successfully:
      "تم تحديث إعدادات الإشعارات بنجاح",
    whatsapp_settings_updated_successfully: "تم تحديث اعدادات واتس اب بنجاح",
    sms_settings_updated_successfully: "تم تحديث اعدادات الرسائل بنجاح",
    profile_updated_successfully: "تم تحديث البروفايل بنجاح",
    profile_added_successfully: "تمت إضافة البروفايل بنجاح",
    reseller_updated_successfully: "تم تحديث الوكيل بنجاح",
    reseller_added_successfully: "تمت اضافة الوكيل بنجاح",
    support_ticket_added_successfully: "تمت اضافة طلب صيانة بنجاح",
    support_ticket_updated_successfully: "تم تحديث طلب الصيانة",
    personal_details_updated_successfully: "تم تعديل البيانات الشخصية بنجاح",
    personal_details_update_failed: "حدث خطأ اثناء تحديث البيانات الشخصية",
  },
};
